// import React, {
//   useEffect,
//   useRef,
//   useState,
// } from "react";
// import { loadStripe } from "@stripe/stripe-js";
// import {
//   Elements,
//   PaymentElement,
//   useElements,
//   useStripe,
// } from "@stripe/react-stripe-js";
// import { Lock, CreditCard, Shield } from "lucide-react";
// import { useAppContext } from "../AppContext";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Button, Modal, Select, AutoComplete } from "antd";
// import TermsAndCondition from "./TermsAndCondition";
// const API_BASE = "https://app.commercialcleaningleadsforyou.com";

// const PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// async function fetchPublishableKeyIfNeeded() {
//   if (PUBLISHABLE_KEY) return PUBLISHABLE_KEY;
//   const res = await fetch(`${API_BASE}/api/config`);
//   if (!res.ok) throw new Error("Cannot reach /api/config.");
//   const data = await res.json();
//   if (!data.publishableKey)
//     throw new Error("Server missing STRIPE_PUBLISHABLE_KEY.");
//   return data.publishableKey;
// }

// const US_STATES = [
//   "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
//   "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland",
//   "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
//   "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
//   "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
// ];

// /* -------------------- Main Form -------------------- */


// function PrettyForm({ hidePlanSelector = false }) {
//   const stripe = useStripe();
//   const elements = useElements();

//   const {
//     name, setName,
//     email, setEmail,
//     phone, setPhone,
//     line1, setLine1,
//     city, setCity,
//     state, setState,
//     postal, setPostal,
//     zipcodes, setZipcodes,
//     buyNow, setBuyNow,
//     orderNumber, setOrderNumber,
//     setClientSecret, clientSecret,
//     selectedPrice, setSelectedPrice,
//     leadsCount, setLeadsCount
//   } = useAppContext();

//   const plans = [
//     { qty: 50, price: 39 },
//     { qty: 200, price: 99 },
//     { qty: 500, price: 199 },
//   ];

//   const [toast, setToast] = useState({ open: false, text: "" });
//   const [successOpen, setSuccessOpen] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const cardRef = useRef(null);
//   const [ready, setReady] = useState(false);

//   const [data, setData] = useState(null);
//   const [error, setError] = useState(null);
//   const [csvtoken, setCsvToken] = useState("");
//   const [zipcodeError, setZipCodeError] = useState(false);
//   const [paymentId, setPaymentId] = useState(null);
//   const [accepted, setAccepted] = useState(false);
//   const [showTerms, setShowTerms] = useState(false);
//   const [downloadAccepted, setDownloadAccepted] = useState(false);
//   const [downloadShowTerms, setDownloadShowTerms] = useState(false);
//   const [hasAgreedToTerms, setHasAgreedToTerms] = useState(false); // Track if user clicked "Agree" in modal
//   const navigate = useNavigate();

//   // Promo code state
//   const [promoCode, setPromoCode] = useState("");
//   const [promoCodeValidating, setPromoCodeValidating] = useState(false);
//   const [promoCodeValid, setPromoCodeValid] = useState(false);
//   const [promoCodeError, setPromoCodeError] = useState("");
//   const [promoCodeDiscount, setPromoCodeDiscount] = useState(0); // 0 to 1 (e.g., 0.25 = 25%)
//   const [promoCodeApplied, setPromoCodeApplied] = useState(false);
//   const [rateLimited, setRateLimited] = useState(false);
//   const [remainingTime, setRemainingTime] = useState(0); // in seconds
//   const [remainingAttempts, setRemainingAttempts] = useState(5);

//   // Discount state (UI only - no backend changes)
//   const originalAmount = selectedPrice || 19900; // Use selected price from context, default to $199.00 in cents
//   const discountPercent = promoCodeDiscount; // Use validated promo code discount
//   const discountAmount = Math.round(originalAmount * discountPercent); // Discount in cents
//   const discountedAmount = originalAmount - discountAmount; // Final amount after discount
//   const isDiscountApplied = promoCodeApplied || hasAgreedToTerms; // Apply discount when promo code is valid OR user agrees to terms


//   // NEW: zip check state
//   const [zipCheckLoading, setZipCheckLoading] = useState(false);
//   const [zipCheckOk, setZipCheckOk] = useState(null); // true | false | null
//   const [zipCheckMsg, setZipCheckMsg] = useState("");
//   const lastZipReqIdRef = useRef(0); // race-avoidance

//   // Address Autocomplete state
//   const [addressSuggestions, setAddressSuggestions] = useState([]);
//   const [isSearchingAddress, setIsSearchingAddress] = useState(false);
//   const addressTimeoutRef = useRef(null);
//   const lastAddressReqIdRef = useRef(0);

//   const isSelectingRef = useRef(false);

//   const handleAddressSearch = (query) => {
//     setLine1(query);

//     if (isSelectingRef.current) return;

//     // Clear city/state/zip when user starts typing a new address
//     setCity("");
//     setState("");
//     setPostal("");

//     if (!query || query.trim().length <= 3) {
//       setAddressSuggestions([]);
//       if (addressTimeoutRef.current) clearTimeout(addressTimeoutRef.current);
//       return;
//     }

//     if (addressTimeoutRef.current) clearTimeout(addressTimeoutRef.current);

//     const requestId = ++lastAddressReqIdRef.current;

//     addressTimeoutRef.current = setTimeout(async () => {
//       try {
//         setIsSearchingAddress(true);
//         // Photon API for free address suggestions
//         const response = await axios.get(`https://photon.komoot.io/api/`, {
//           params: {
//             q: query,
//             limit: 8,
//           }
//         });

//         if (requestId !== lastAddressReqIdRef.current) return;

//         const suggestions = response.data.features
//           .filter(f => f.properties.country === "United States")
//           .map(f => {
//             const prop = f.properties;
//             const house = prop.housenumber ? prop.housenumber + " " : "";
//             const street = prop.street || prop.name || "";
//             const line1Value = (house + street).trim();
//             const cityValue = prop.city || prop.town || "";
//             const stateValue = prop.state || "";
//             const zipValue = prop.postcode || "";

//             const displayLabel = `${line1Value}${cityValue ? ', ' + cityValue : ''}${stateValue ? ', ' + stateValue : ''} ${zipValue}`.trim();

//             return {
//               value: displayLabel,
//               label: (
//                 <div className="py-1">
//                   <div className="font-medium text-gray-800">{line1Value}</div>
//                   <div className="text-xs text-gray-500">{cityValue}{cityValue && stateValue ? ', ' : ''}{stateValue} {zipValue}</div>
//                 </div>
//               ),
//               data: {
//                 line1: line1Value,
//                 city: cityValue,
//                 state: stateValue,
//                 zip: zipValue
//               }
//             };
//           });
//         setAddressSuggestions(suggestions);
//       } catch (error) {
//         console.error("Error fetching address suggestions:", error);
//       } finally {
//         if (requestId === lastAddressReqIdRef.current) {
//           setIsSearchingAddress(false);
//         }
//       }
//     }, 400);
//   };

//   const handleAddressSelect = (value, option) => {
//     isSelectingRef.current = true;
//     const { data } = option;
//     if (data.line1) setLine1(data.line1);
//     if (data.city) setCity(data.city);
//     if (data.state) {
//       // Try to find the state in our US_STATES list (case insensitive)
//       const matchedState = US_STATES.find(s => s.toLowerCase() === data.state.toLowerCase());
//       if (matchedState) {
//         setState(matchedState);
//       } else {
//         setState(data.state);
//       }
//     }
//     if (data.zip) setPostal(data.zip);

//     // Reset selection flag after state updates propagate
//     setTimeout(() => {
//       isSelectingRef.current = false;
//     }, 300);
//   };

//   // Rate limit timer for UI updates
//   const rateLimitTimerRef = useRef(null);

//   useEffect(() => {
//     if (!toast.open) return;
//     const t = setTimeout(() => setToast({ open: false, text: "" }), 6000);
//     return () => clearTimeout(t);
//   }, [toast.open]);

//   // Helper function to calculate remaining time from expiration timestamp
//   const calculateRemainingTime = (expiresAt) => {
//     if (!expiresAt) return 0;
//     const now = Date.now();
//     const remaining = Math.max(0, Math.ceil((expiresAt - now) / 1000));
//     return remaining;
//   };

//   // Helper function to start countdown timer
//   const startCountdownTimer = (expiresAt) => {
//     if (rateLimitTimerRef.current) {
//       clearInterval(rateLimitTimerRef.current);
//     }

//     const updateRemainingTime = () => {
//       const remaining = calculateRemainingTime(expiresAt);
//       setRemainingTime(remaining);

//       if (remaining <= 0) {
//         clearInterval(rateLimitTimerRef.current);
//         setRateLimited(false);
//         setRemainingTime(0);
//         // Clear from localStorage
//         localStorage.removeItem('promoRateLimitExpiresAt');
//       }
//     };

//     // Update immediately
//     updateRemainingTime();

//     // Update every second
//     rateLimitTimerRef.current = setInterval(updateRemainingTime, 1000);
//   };

//   // Restore rate limit state from localStorage and backend on mount
//   useEffect(() => {
//     const restoreRateLimitState = async () => {
//       try {
//         // First check localStorage for cached expiration
//         const cachedExpiresAt = localStorage.getItem('promoRateLimitExpiresAt');
//         if (cachedExpiresAt) {
//           const expiresAt = parseInt(cachedExpiresAt, 10);
//           const remaining = calculateRemainingTime(expiresAt);

//           if (remaining > 0) {
//             // Still rate limited, restore from cache
//             setRateLimited(true);
//             setRemainingTime(remaining);
//             startCountdownTimer(expiresAt);
//             return; // Use cached data, no need to query backend
//           } else {
//             // Expired, clear cache
//             localStorage.removeItem('promoRateLimitExpiresAt');
//           }
//         }

//         // Query backend for current status
//         const response = await fetch(`${API_BASE}/api/check-rate-limit-status`, {
//           method: "GET",
//           headers: { "Content-Type": "application/json" },
//         });

//         if (response.ok) {
//           const data = await response.json();

//           if (data.blocked && data.expiresAt) {
//             const expiresAt = data.expiresAt;
//             const remaining = calculateRemainingTime(expiresAt);

//             if (remaining > 0) {
//               // User is still rate limited
//               setRateLimited(true);
//               setRemainingTime(remaining);
//               // Store in localStorage
//               localStorage.setItem('promoRateLimitExpiresAt', expiresAt.toString());
//               startCountdownTimer(expiresAt);
//             } else {
//               // Expired, clear state
//               setRateLimited(false);
//               setRemainingTime(0);
//               localStorage.removeItem('promoRateLimitExpiresAt');
//             }
//           } else {
//             // Not rate limited, ensure state is cleared
//             setRateLimited(false);
//             setRemainingTime(0);
//             localStorage.removeItem('promoRateLimitExpiresAt');
//           }

//           // Update remaining attempts if not blocked
//           if (!data.blocked) {
//             setRemainingAttempts(data.remainingAttempts || 5);
//           }
//         }
//       } catch (error) {
//         console.error("Error checking rate limit status:", error);
//         // On error, try to use localStorage if available
//         const cachedExpiresAt = localStorage.getItem('promoRateLimitExpiresAt');
//         if (cachedExpiresAt) {
//           const expiresAt = parseInt(cachedExpiresAt, 10);
//           const remaining = calculateRemainingTime(expiresAt);
//           if (remaining > 0) {
//             setRateLimited(true);
//             setRemainingTime(remaining);
//             startCountdownTimer(expiresAt);
//           }
//         }
//       }
//     };

//     restoreRateLimitState();

//     // Cleanup on unmount
//     return () => {
//       if (rateLimitTimerRef.current) {
//         clearInterval(rateLimitTimerRef.current);
//       }
//     };
//   }, []); // Only run on mount

//   const showError = (msg) => setToast({ open: true, text: msg });
//   const closeError = () => setToast({ open: false, text: "" });

//   const validatePersonal = () => {
//     if (!name || !email || !line1 || !city || !state || !postal) {
//       showError("Please complete all required personal details.");
//       return false;
//     }
//     return true;
//   };

//   const [loadings, setLoadings] = useState(false);
//   const [message, setMessage] = useState("");

//   const getFilenameFromHeaders = (resp) => {
//     const cd = resp.headers.get("content-disposition");
//     if (!cd) return null;
//     const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd);
//     return decodeURIComponent(m?.[1] || m?.[2] || "");
//   };

//   const [ip, setIp] = useState();

//   useEffect(() => {
//     const getIpDetails = async () => {
//       try {
//         const response = await axios.get("https://ipinfo.io/json");
//         setIp(response.data);
//       } catch (error) {
//         console.error("Error fetching IP details:", error);
//       }
//     };

//     getIpDetails();
//   }, []);

//   async function postDownloadStatus(paymentId, status) {
//     if (!paymentId) return;
//     try {
//       await fetch(`${API_BASE}/api/update-download-status`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ paymentId, downloadStatus: status }),
//       });
//     } catch (e) {
//       console.warn("update-download-status failed:", e);
//     }
//   }

//   // NEW: zipcode check API (race-safe & awaitable)
//   const zipcodeCheckAPI = async () => {
//     const currentZip = (zipcodes || "").trim();

//     if (!/^[0-9,\s-]{3,100}$/.test(currentZip)) {
//       setZipCodeError(true);
//       setZipCheckOk(false);
//       setZipCheckMsg("Please enter valid zipcode(s).");
//       setCsvToken("");
//       return { ok: false };
//     }

//     const reqId = ++lastZipReqIdRef.current;
//     setZipCheckLoading(true);
//     setZipCodeError(false);
//     setZipCheckOk(null);
//     setZipCheckMsg("Checking…");

//     try {
//       const response = await fetch("https://api.usfarmdata.org/capstone/check-csv", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           zipcode: currentZip,
//           leads_count: leadsCount || 50
//         }),
//       });

//       if (reqId !== lastZipReqIdRef.current) return { ok: false, ignored: true };

//       if (!response.ok) {
//         setZipCodeError(true);
//         setZipCheckOk(false);
//         setZipCheckMsg("Zipcode details not found.");
//         setCsvToken("");
//         return { ok: false };
//       }

//       const result = await response.json();
//       const ok = Boolean(result?.token);
//       setCsvToken(result?.token || "");
//       setData(result?.status);
//       setZipCodeError(!ok);
//       setZipCheckOk(ok);
//       setZipCheckMsg(ok ? "Zipcodes verified." : "Zipcode details not found.");
//       return { ok };
//     } catch (err) {
//       if (reqId !== lastZipReqIdRef.current) return { ok: false, ignored: true };
//       setZipCodeError(true);
//       setZipCheckOk(false);
//       setZipCheckMsg("Could not verify zipcodes. Try again.");
//       setCsvToken("");
//       return { ok: false };
//     } finally {
//       if (reqId === lastZipReqIdRef.current) {
//         setZipCheckLoading(false);
//       }
//     }
//   };

//   // Trigger check when zipcodes change
//   useEffect(() => {
//     if ((zipcodes || "").trim().length >= 5) {
//       zipcodeCheckAPI();
//     } else {
//       setZipCheckLoading(false);
//       setZipCheckOk(null);
//       setZipCodeError(false);
//       setZipCheckMsg("");
//       setCsvToken("");
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [zipcodes]);

//   const handleDownload = async (e) => {
//     e.preventDefault();

//     // NEW: gate download by zipcode check
//     if (zipCheckLoading) {
//       alert("We’re still verifying your zipcodes. Please wait a moment.");
//       return;
//     }
//     if (!csvtoken) {
//       const finalCheck = await zipcodeCheckAPI();
//       if (!finalCheck?.ok) {
//         alert(zipCheckMsg || "Zipcode verification failed. Please review and try again.");
//         return;
//       }
//     }

//     if (!/^[0-9,\s-]{3,100}$/.test(zipcodes)) {
//       alert("Please enter valid zipcode(s).");
//       return;
//     }

//     setLoadings?.(true);

//     // ensure we only post one status
//     let statusPosted = false;
//     const postOnce = async (status) => {
//       if (statusPosted) return;
//       statusPosted = true;
//       await postDownloadStatus(paymentId, status);
//     };

//     try {
//       const resp = await fetch(`${API_BASE}/api/download-csv`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           zipcode: zipcodes,
//           token: csvtoken,
//           email,
//           orderno: orderNumber,
//           paymentId: paymentId,
//           leads_count: leadsCount || 50
//         }),
//       });

//       if (!resp.ok) {
//         await postOnce("No");
//         const text = await resp.text();
//         let message = text;
//         try { message = JSON.parse(text).error || message; } catch { }
//         throw new Error(message || `Request failed: ${resp.status}`);
//       }

//       // 200 OK → immediately mark as Yes
//       await postOnce("Yes");

//       // Then download the CSV
//       const blob = await resp.blob();
//       const url = URL.createObjectURL(blob);
//       const filename =
//         getFilenameFromHeaders(resp) || `${zipcodes.replace(/[^\d, -]/g, "")}.csv`;

//       const a = document.createElement("a");
//       a.href = url;
//       a.download = filename;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       URL.revokeObjectURL(url);

//       setCity?.("");
//       setLine1?.("");
//       setPhone?.("");
//       setPostal?.("");
//       setState?.("");
//       setName?.("");
//       setSuccessOpen?.(false);
//       navigate('/thank-you')

//     } catch (err) {
//       console.error(err);
//       await postOnce("No");
//       alert("Error downloading file");
//     } finally {
//       setLoadings?.(false);
//     }
//   };

//   function ErrorToast({ open, text, onClose }) {
//     if (!open) return null;
//     return (
//       <div className="fixed z-50 bottom-6 inset-x-0 px-4">
//         <div className="mx-auto max-w-md">
//           <div className="flex items-center justify-between rounded-xl bg-gradient-to-r from-red-500 to-rose-600 text-white shadow-lg px-4 py-3">
//             <div className="flex items-center">
//               <span className="mr-3 text-xl">⚠️</span>
//               <div className="font-medium">{text}</div>
//             </div>
//             <button onClick={onClose} className="text-white/90 hover:text-white">
//               ✕
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   function SuccessModal({ open, text, onClose }) {
//     const navigate = useNavigate();
//     const handleContinue = () => {
//       if (onClose) onClose();
//       navigate("/");
//     };
//     const handleClose = () => {
//       setSuccessOpen(false);
//     };
//     if (!open) return null;
//     return (
//       <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
//         <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl p-6 text-center">
//           <div className="mx-auto w-14 h-14 rounded-full bg-green-100 flex items-center justify-center mb-4">
//             <span className="text-2xl">✔</span>
//           </div>
//           <h3 className="text-xl font-semibold text-gray-800">
//             Payment Successful!
//           </h3>
//           <p className="text-gray-500 mt-2">
//             {text || "Your payment was completed successfully."}
//           </p>
//           <button
//             onClick={handleDownload}
//             disabled={loadings}
//             className="mt-6 inline-flex items-center justify-center rounded-xl bg-[#26A94A] px-5 py-3 text-white font-semibold hover:from-indigo-700 hover:to-purple-700 shadow cursor-pointer"
//           >
//             {loadings ? 'Downloading…' : `Download`}
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const [baseAmount, setBaseAmount] = useState(selectedPrice || 19900); // Use selected price from context, default to $199.00 in cents
//   const [finalAmount, setFinalAmount] = useState(baseAmount);

//   const handleConfirmPayment = async (e) => {
//     e.preventDefault();

//     if (!stripe || !elements) return;

//     // NEW: block while checking
//     if (zipCheckLoading) {
//       showError("We're still verifying your zipcodes. Please wait a moment.");
//       return;
//     }

//     // NEW: force final check if user clicked fast
//     if (!csvtoken) {
//       const finalCheck = await zipcodeCheckAPI();
//       if (!finalCheck?.ok) {
//         showError(zipCheckMsg || "Zipcode verification failed. Please review and try again.");
//         return;
//       }
//     }

//     // Safety net
//     if (zipcodeError || zipCheckOk === false) {
//       showError(zipCheckMsg || "Zipcode details not found.");
//       return;
//     }

//     const submitResult = await elements.submit();
//     if (submitResult?.error) {
//       showError(submitResult.error.message);
//       return;
//     }

//     if (!validatePersonal()) return;

//     setSubmitting(true);
//     try {
//       // Generate order number in US timezone
//       const usDate = new Date().toLocaleString("en-US", {
//         timeZone: "America/Chicago",
//       });

//       const now = new Date(usDate);
//       const pad = (n) => n.toString().padStart(2, "0");

//       const year = now.getFullYear();
//       const month = pad(now.getMonth() + 1);
//       const day = pad(now.getDate());
//       const hours = pad(now.getHours());
//       const minutes = pad(now.getMinutes());
//       const seconds = pad(now.getSeconds());

//       const orderno = `${year}${month}${day}${hours}${minutes}${seconds}`;
//       setOrderNumber(orderno);

//       const finalAmount = isDiscountApplied ? discountedAmount : originalAmount;

//       // Extract paymentIntentId from clientSecret (format: pi_xxx_secret_xxx)
//       let paymentIntentId = null;
//       let currentClientSecret = clientSecret; // Track the current clientSecret
//       if (clientSecret) {
//         const parts = clientSecret.split('_secret_');
//         if (parts.length === 2) {
//           paymentIntentId = parts[0];
//         }
//       }

//       // CRITICAL: Update PaymentIntent amount BEFORE creating payment record
//       // This ensures the PaymentIntent has the correct discounted amount when we confirm payment
//       // Note: This should already be updated when promo code was validated, but do a final check
//       if (isDiscountApplied && paymentIntentId && finalAmount !== originalAmount) {
//         try {
//           const updateRes = await fetch(`${API_BASE}/api/update-payment-intent-amount`, {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//               paymentIntentId: paymentIntentId,
//               amount: finalAmount
//             }),
//           });

//           const updateData = await updateRes.json();
//           // Check if the update was successful
//           if (!updateRes.ok) {
//             throw new Error(updateData?.error || "Failed to update payment amount");
//           }
//           // If backend returns success field, check it; otherwise assume success if status is OK
//           if (updateData.success === false) {
//             throw new Error(updateData?.error || "Failed to update payment amount");
//           }

//           // If backend returns a new clientSecret, update it (though usually it stays the same)
//           if (updateData.clientSecret) {
//             currentClientSecret = updateData.clientSecret;
//             setClientSecret(updateData.clientSecret);
//             // Wait for React to re-render and Elements to potentially remount
//             await new Promise(resolve => setTimeout(resolve, 300));
//           }
//         } catch (updateErr) {
//           console.error("Error updating payment intent amount:", updateErr);
//           throw new Error(`Failed to apply discount: ${updateErr.message}`);
//         }
//       }

//       // Now create the payment record with the correct amount
//       // Pass paymentIntentId so backend knows which PaymentIntent to use
//       const createRes = await fetch(`${API_BASE}/api/create-payment-onetime`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           email,
//           name,
//           amount: finalAmount, // Use discounted amount if promo code is applied
//           originalAmount: originalAmount, // Add the original amount before discount
//           couponApplied: promoCodeApplied, // Boolean indicating if promo code is applied
//           discountPercentage: Math.round(promoCodeDiscount * 100), // The discount percentage
//           promoCode: promoCodeApplied ? promoCode.trim().toUpperCase() : null, // Promo code used
//           currency: "usd",
//           glsZipCode: zipcodes,
//           phone,
//           address: line1,
//           city,
//           state,
//           zipcode: postal,
//           user_city: ip?.city,
//           user_postal: ip?.postal,
//           user_region: ip?.region,
//           user_loc: ip?.loc,
//           user_ip: ip?.ip,
//           orderno,
//           paymentIntentId: paymentIntentId, // Pass paymentIntentId so backend can link/update it
//         }),
//       });
//       const createData = await createRes.json().catch(() => null);
//       if (!createRes.ok || !createData?.paymentId)
//         throw new Error(createData?.error || "Payment creation failed");

//       const paymentId = createData.paymentId;
//       setPaymentId(paymentId);

//       // If backend returns a new clientSecret (e.g., if it created a new PaymentIntent), update it
//       if (createData.clientSecret && createData.clientSecret !== currentClientSecret) {
//         setClientSecret(createData.clientSecret);
//         // Wait for Elements to re-initialize with new PaymentIntent
//         await new Promise(resolve => setTimeout(resolve, 500));
//         // Note: At this point, elements might be stale, but confirmPayment should handle this
//         // by using the clientSecret from Elements' configuration
//       }

//       // Confirm payment - Stripe will use the PaymentIntent associated with the elements
//       // Since we updated the PaymentIntent amount above, it should charge the discounted amount
//       const { error, paymentIntent } = await stripe.confirmPayment({
//         elements,
//         confirmParams: { receipt_email: email },
//         redirect: "if_required",
//       });

//       if (error) throw new Error(error.message);
//       if (paymentIntent?.status !== "succeeded")
//         throw new Error(`Payment not completed (status: ${paymentIntent?.status}).`);

//       await fetch(`${API_BASE}/api/sync-payment-intent`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ paymentIntentId: paymentIntent.id, paymentId }),
//       });

//       setBuyNow("download");
//     } catch (err) {
//       showError(err?.message || "Something went wrong.");
//     } finally {
//       setSubmitting(false);
//     }
//   };


//   // Validate promo code
//   const validatePromoCode = async (code) => {
//     if (!code || code.trim() === "") {
//       setPromoCodeValid(false);
//       setPromoCodeApplied(false);
//       setPromoCodeDiscount(0);
//       setPromoCodeError("");
//       setRateLimited(false);
//       return;
//     }

//     setPromoCodeValidating(true);
//     setPromoCodeError("");
//     setRateLimited(false);

//     try {
//       const response = await fetch(`${API_BASE}/api/validate-promo-code`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ promoCode: code.trim() }),
//       });

//       const data = await response.json();

//       if (data.valid) {
//         // Valid promo code
//         setPromoCodeValid(true);
//         setPromoCodeApplied(true);
//         setPromoCodeDiscount(data.discount);
//         setPromoCodeError("");
//         setRateLimited(false);
//         setRemainingTime(0);
//         // Clear rate limit from localStorage when promo code is valid
//         localStorage.removeItem('promoRateLimitExpiresAt');
//         if (rateLimitTimerRef.current) {
//           clearInterval(rateLimitTimerRef.current);
//         }

//         // Update payment intent amount if available
//         await updatePaymentIntentWithDiscount(data.discount);
//       } else {
//         // Invalid promo code or rate limited
//         setPromoCodeValid(false);
//         setPromoCodeApplied(false);
//         setPromoCodeDiscount(0);
//         setPromoCodeError(data.message || data.error || "Invalid promo code");

//         if (data.rateLimited && data.expiresAt) {
//           // Rate limited - store expiration timestamp and start countdown
//           const expiresAt = data.expiresAt;
//           setRateLimited(true);
//           localStorage.setItem('promoRateLimitExpiresAt', expiresAt.toString());
//           startCountdownTimer(expiresAt);
//         } else {
//           setRateLimited(false);
//           setRemainingTime(0);
//           setRemainingAttempts(data.remainingAttempts || 5);
//         }

//         // Update payment intent to remove discount
//         await updatePaymentIntentWithDiscount(0);
//       }
//     } catch (error) {
//       console.error("Error validating promo code:", error);
//       setPromoCodeValid(false);
//       setPromoCodeApplied(false);
//       setPromoCodeDiscount(0);
//       setPromoCodeError("Failed to validate promo code. Please try again.");
//       await updatePaymentIntentWithDiscount(0);
//     } finally {
//       setPromoCodeValidating(false);
//     }
//   };

//   // Update payment intent with discount
//   const updatePaymentIntentWithDiscount = async (discountPercent) => {
//     let paymentIntentId = null;
//     if (clientSecret) {
//       const parts = clientSecret.split('_secret_');
//       if (parts.length === 2) {
//         paymentIntentId = parts[0];
//       }
//     }

//     if (!paymentIntentId) return;

//     const currentBaseAmount = selectedPrice || 19900;
//     const discountedAmount = Math.round(currentBaseAmount * (1 - discountPercent));

//     try {
//       const updateRes = await fetch(`${API_BASE}/api/update-payment-intent-amount`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           paymentIntentId: paymentIntentId,
//           amount: discountedAmount
//         }),
//       });

//       const updateData = await updateRes.json();
//       if (!updateRes.ok) {
//         throw new Error(updateData?.error || "Failed to update payment amount");
//       }
//       if (updateData.success === false) {
//         throw new Error(updateData?.error || "Failed to update payment amount");
//       }

//       if (updateData.clientSecret) {
//         setClientSecret(updateData.clientSecret);
//       }
//     } catch (error) {
//       console.error("Error updating payment amount:", error);
//     }
//   };

//   // Handle promo code input change
//   const handlePromoCodeChange = async (value) => {
//     setPromoCode(value);
//     // Clear validation state when user types
//     if (value.trim() === "") {
//       setPromoCodeValid(false);
//       setPromoCodeApplied(false);
//       setPromoCodeDiscount(0);
//       setPromoCodeError("");
//       setRateLimited(false);
//       // Reset payment intent to original amount when promo code is cleared
//       await updatePaymentIntentWithDiscount(0);
//     }
//   };

//   // Handle promo code validation on blur or Enter key
//   const handlePromoCodeSubmit = () => {
//     if (promoCode.trim()) {
//       validatePromoCode(promoCode);
//     }
//   };

//   useEffect(() => {
//     const price = selectedPrice || 19900;
//     setBaseAmount(price);
//     const discount = promoCodeApplied ? promoCodeDiscount : 0;
//     setFinalAmount(Math.round(price * (1 - discount)));
//   }, [promoCodeApplied, promoCodeDiscount, selectedPrice]);
//   const handleAgree = () => {
//     setAccepted(true);
//     setHasAgreedToTerms(true); // Apply discount after agreeing to terms
//     setShowTerms(false);
//   };

//   const handleDownloadAgree = () => {
//     setDownloadAccepted(true);
//     setDownloadShowTerms(false);
//   };

//   return (
//     <div>
//       <ErrorToast open={toast.open} text={toast.text} onClose={closeError} />
//       <SuccessModal
//         open={successOpen}
//         text="Please check the mail for detailed report"
//         onClose={() => handleClose()}
//       />

//       {buyNow === 'payment' && (
//         <div className="max-w-xl mx-auto mb-8">
//           <div className="shadow-2xl border-6 border-[#26A94A] rounded-2xl overflow-hidden bg-white/80 backdrop-blur-sm">
//             <div className="bg-[#26A94A] p-4 text-white">
//               <div className="flex justify-between items-center">
//                 <div className="w-[50%]">
//                   <h2 className="text-xl font-bold">Payment Details</h2>
//                   <p className="text-indigo-100">Secure payment processing</p>
//                 </div>
//                 <Shield className="h-10 w-10 text-white/80 " />
//               </div>
//               <div className="mt-2 bg-[#cccc4b] rounded-xl p-4 backdrop-blur-sm">
//                 <div className="space-y-2">
//                   <div className="flex justify-between items-center">
//                     <div>
//                       <div className="text-[#1465B7] text-lg">Subtotal</div>
//                       <div className="text-[#1465B7] text-2xl font-bold">${(originalAmount / 100).toFixed(2)}</div>
//                     </div>
//                     <CreditCard className="h-8 w-8 text-[#1465B7]" />
//                   </div>
//                   {isDiscountApplied && (
//                     <div className="pt-2 border-t border-[#1465B7]/20">
//                       <div className="flex justify-between items-center text-[#1465B7]">
//                         <div className="flex items-center gap-2">
//                           <span className="text-sm font-medium">
//                             {promoCodeApplied
//                               ? `${Math.round(promoCodeDiscount * 100)}% Discount${promoCode ? ` (${promoCode.trim().toUpperCase()})` : ''}`
//                               : "25% Discount"}
//                           </span>
//                           <span className="text-xs bg-green-500 text-white px-2 py-0.5 rounded-full font-semibold">Applied</span>
//                         </div>
//                         <div className="text-lg font-semibold">-${(discountAmount / 100).toFixed(2)}</div>
//                       </div>
//                     </div>
//                   )}
//                   <div className="pt-2 border-t-2 border-[#1465B7]/30">
//                     <div className="flex justify-between items-center">
//                       <div className="text-[#1465B7] text-lg font-semibold">Total amount</div>
//                       <div className="text-[#1465B7] text-2xl font-bold">
//                         ${((isDiscountApplied ? discountedAmount : originalAmount) / 100).toFixed(2)}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="p-6">
//               <form onSubmit={handleConfirmPayment}>
//                 <div className="space-y-5">
//                   <div className="space-y-4">
//                     {!hidePlanSelector && <div className="space-y-2">
//                       <label className="text-md text-gray-700 font-medium mb-2 block text-center">
//                         Choose which plan works best for you:
//                       </label>

//                       {/* 50 / 200 / 500 Leads row */}
//                       <div className="flex justify-center mb-6">
//                         <div
//                           className="
//                   w-full max-w-sm
//                   bg-[#BFEAF2]
//                   border-[3px] border-[#26A94A]
//                   rounded-xl
//                   overflow-hidden
//                   grid grid-cols-3
//                 "
//                         >
//                           {plans.map((p, idx) => (
//                             <button
//                               key={p.qty}
//                               type="button"
//                               onClick={() => {
//                                 setLeadsCount(p.qty);
//                                 setSelectedPrice(p.price * 100);
//                               }}
//                               className={`
//                       py-2
//                       flex flex-col items-center justify-center
//                       transition
//                       cursor-pointer
//                       ${idx !== 0 ? "border-l-[3px] border-[#26A94A]" : ""}
//                       ${leadsCount === p.qty ? "bg-[#85C1CF]" : ""}
//                     `}
//                             >
//                               <span
//                                 className="
//                         text-lg sm:text-xl 
//                         font-extrabold leading-none
//                         text-[#26A94A]
//                         drop-shadow-[1px_1px_0px_#FFFFFF]
//                       "
//                               >
//                                 {p.qty}
//                               </span>
//                               <span className="text-sm font-extrabold leading-none text-[#1465B7]">
//                                 Leads
//                               </span>
//                               <span className="text-sm font-extrabold leading-none text-[#26A94A] my-1">
//                                 ${p.price}
//                               </span>
//                             </button>
//                           ))}
//                         </div>
//                       </div>
//                     </div>}

//                     <div className="space-y-2">
//                       <label className="text-md text-gray-700 font-medium">
//                         Send me these leads around my zipcode:
//                       </label>
//                       <div className="w-full flex justify-center items-center mt-2">
//                         <input
//                           value={zipcodes}
//                           onChange={(e) => setZipcodes(e.target.value)}
//                           placeholder="12345"
//                           className="py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500 mx-auto max-w-md"
//                         />
//                       </div>

//                       {/* Inline status line */}
//                       {(zipcodes?.trim()?.length >= 5) && (
//                         <div className="mt-2 text-center">
//                           {zipCheckLoading && <p className="text-sm text-gray-500">Checking zipcodes…</p>}
//                           {!zipCheckLoading && zipCheckOk === true && (
//                             <p className="text-sm text-green-600">Zipcodes verified.</p>
//                           )}
//                           {!zipCheckLoading && zipCheckOk === false && (
//                             <p className="text-sm text-red-500">{zipCheckMsg || "Zipcode details not found."}</p>
//                           )}
//                         </div>
//                       )}
//                     </div>

//                     <div className="grid grid-cols-2 gap-4">
//                       <div className="space-y-2">
//                         <label className="text-sm font-medium text-gray-700">
//                           Full Name <span className="text-red-600">*</span>
//                         </label>
//                         <input
//                           value={name}
//                           onChange={(e) => setName(e.target.value)}
//                           placeholder="John Doe"
//                           autoComplete="name"
//                           required
//                           className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
//                         />
//                       </div>

//                       <div className="space-y-2">
//                         <label className="text-sm font-medium text-gray-700">
//                           Email Address <span className="text-red-600">*</span>
//                         </label>
//                         <input
//                           type="email"
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                           placeholder="you@example.com"
//                           autoComplete="email"
//                           required
//                           className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
//                         />
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-2 gap-4">
//                       <div className="space-y-2">
//                         <label className="text-sm font-medium text-gray-700">
//                           Phone Number <span className="text-red-600">*</span>
//                         </label>
//                         <input
//                           value={phone}
//                           onChange={(e) => setPhone(e.target.value)}
//                           placeholder="+1 (555) 123-4567"
//                           inputMode="tel"
//                           autoComplete="tel"
//                           required
//                           className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
//                         />
//                       </div>

//                       <div className="space-y-2">
//                         <label className="text-sm font-medium text-gray-700">
//                           Street Address <span className="text-red-600">*</span>
//                         </label>
//                         <AutoComplete
//                           options={addressSuggestions}
//                           onSearch={handleAddressSearch}
//                           onSelect={handleAddressSelect}
//                           value={line1}
//                           className="w-full"
//                           defaultActiveFirstOption={false}
//                           filterOption={false}
//                         >
//                           <input
//                             placeholder="123 Main St"
//                             className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
//                             required
//                           />
//                         </AutoComplete>
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-3 gap-4">
//                       <div className="space-y-2">
//                         <label className="text-sm font-medium text-gray-700">
//                           City <span className="text-red-600">*</span>
//                         </label>
//                         <input
//                           value={city}
//                           onChange={(e) => setCity(e.target.value)}
//                           placeholder="City"
//                           autoComplete="address-level2"
//                           required
//                           className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
//                         />
//                       </div>
//                       <div className="space-y-2">
//                         <label className="text-sm font-medium text-gray-700">
//                           State <span className="text-red-600">*</span>
//                         </label>
//                         <Select
//                           showSearch
//                           value={state || undefined}
//                           onChange={(value) => setState(value)}
//                           placeholder="Select State"
//                           className="w-full h-[50px] custom-select"
//                           optionFilterProp="label"
//                           filterOption={(input, option) =>
//                             (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
//                           }
//                           options={US_STATES.map(s => ({ label: s, value: s }))}
//                         />
//                       </div>
//                       <div className="space-y-2">
//                         <label className="text-sm font-medium text-gray-700">
//                           ZIP Code <span className="text-red-600">*</span>
//                         </label>
//                         <input
//                           value={postal}
//                           onChange={(e) => setPostal(e.target.value)}
//                           placeholder="ZIP"
//                           inputMode="numeric"
//                           autoComplete="postal-code"
//                           required
//                           className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
//                         />
//                       </div>
//                     </div>

//                     <div className="space-y-2">
//                       <div className="border rounded-xl p-3">
//                         <PaymentElement options={{ layout: "tabs" }} />
//                       </div>
//                     </div>

//                     <div className="flex items-center gap-3 ml-1">
//                       <input
//                         id="accept"
//                         type="checkbox"
//                         checked={accepted}
//                         onChange={(e) => setAccepted(e.target.checked)}
//                         className="mt-2 h-4 w-4 cursor-pointer rounded border-slate-600 bg-slate-900 text-indigo-600 focus:ring-indigo-500"
//                         aria-describedby="terms-help"
//                       />
//                       <label htmlFor="accept" className="text-sm text-gray-700 leading-relaxed">
//                         I've read and accept the{" "}
//                         <button
//                           type="button"
//                           className="font-medium underline-offset-2 underline cursor-pointer"
//                           onClick={() => setShowTerms(true)}
//                           aria-label="Read the full Terms and Conditions"
//                           style={{ color: 'blue' }}
//                         >
//                           Terms & Conditions
//                         </button>
//                       </label>
//                     </div>
//                     {/* Promo Code Input */}
//                     <div className="mt-4">
//                       <label htmlFor="promoCode" className="block text-sm font-medium text-gray-700 mb-2">
//                         Promo Code
//                       </label>
//                       <div className="flex gap-2">
//                         <input
//                           id="promoCode"
//                           type="text"
//                           value={promoCode}
//                           onChange={(e) => handlePromoCodeChange(e.target.value)}
//                           onBlur={handlePromoCodeSubmit}
//                           onKeyDown={(e) => {
//                             if (e.key === "Enter") {
//                               e.preventDefault();
//                               handlePromoCodeSubmit();
//                             }
//                           }}
//                           placeholder="Enter promo code"
//                           disabled={promoCodeValidating || rateLimited}
//                           className={`flex-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${promoCodeValid
//                             ? "border-green-500 focus:ring-green-500"
//                             : promoCodeError
//                               ? "border-red-500 focus:ring-red-500"
//                               : "border-gray-300 focus:ring-indigo-500"
//                             } disabled:opacity-50 disabled:cursor-not-allowed`}
//                           aria-describedby="promo-code-help"
//                         />
//                         <button
//                           type="button"
//                           onClick={handlePromoCodeSubmit}
//                           disabled={promoCodeValidating || !promoCode.trim() || rateLimited}
//                           className="px-4 py-2 bg-[#26A94A] text-white rounded-lg hover:bg-[#1e7a3a] disabled:opacity-50 disabled:cursor-not-allowed font-medium cursor-pointer"
//                         >
//                           {promoCodeValidating ? "Validating..." : "Apply"}
//                         </button>
//                       </div>

//                       {/* Validation Messages */}
//                       {promoCodeValidating && (
//                         <p id="promo-code-help" className="mt-2 text-sm text-gray-600">
//                           Validating promo code...
//                         </p>
//                       )}

//                       {promoCodeValid && promoCodeApplied && (
//                         <p id="promo-code-help" className="mt-2 text-sm text-green-600 font-medium">
//                           ✓ Promo code applied! {Math.round(promoCodeDiscount * 100)}% discount
//                         </p>
//                       )}

//                       {promoCodeError && !rateLimited && (
//                         <p id="promo-code-help" className="mt-2 text-sm text-red-600">
//                           {promoCodeError}
//                           {remainingAttempts > 0 && remainingAttempts < 5 && (
//                             <span className="block mt-1">
//                               {remainingAttempts === 1
//                                 ? "You have one more attempt remaining."
//                                 : `You have ${remainingAttempts} more attempts remaining.`}
//                             </span>
//                           )}
//                         </p>
//                       )}

//                       {rateLimited && (
//                         <div id="promo-code-help" className="mt-2 text-sm text-red-600">
//                           <p className="font-medium">Too many failed attempts. Please try again later.</p>
//                           <p className="mt-1">
//                             Time remaining: {Math.floor(remainingTime / 60)}:{String(remainingTime % 60).padStart(2, "0")}
//                           </p>
//                         </div>
//                       )}
//                     </div>

//                   </div>

//                   <button
//                     type="submit"
//                     disabled={
//                       !stripe ||
//                       submitting ||
//                       (zipcodes.length >= 5 && zipcodeError) ||
//                       !accepted ||
//                       zipcodes.length < 5 ||
//                       zipCheckLoading ||           // block while checking
//                       (!csvtoken && !zipCheckLoading) // optional: keep disabled until verified
//                     }
//                     className="py-3 px-6 rounded-xl bg-[#26A94A] text-white font-semibold shadow hover:from-indigo-700 hover:to-purple-700 cursor-pointer disabled:opacity-60 w-full"
//                   >
//                     {submitting
//                       ? "Processing..."
//                       : zipCheckLoading
//                         ? "Verifying zipcodes…"
//                         : `Pay $${((isDiscountApplied ? discountedAmount : originalAmount) / 100).toFixed(2)}`}
//                   </button>
//                 </div>
//               </form>

//               <div className="flex items-center justify-center pt-6">
//                 <Lock className="h-4 w-4 text-indigo-500 mr-2 mb-3" />
//                 <p className="text-xs text-gray-500 mt-1">
//                   Your payment details are securely encrypted
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {buyNow === 'download' && (
//         <div className="w-full max-w-lg">
//           <div className="shadow-2xl border-6 border-[#26A94A] rounded-2xl overflow-hidden bg-white/80 backdrop-blur-sm">
//             <div
//               className="min-h-[24rem] p-8 flex flex-col items-center mt-3 text-center gap-5"
//               role="status"
//               aria-live="polite"
//             >
//               <div className="relative">
//                 <span className="absolute inset-0 rounded-full animate-ping bg-emerald-400/40"></span>
//                 <div className="relative z-10 grid h-16 w-16 place-items-center rounded-full bg-emerald-100 text-emerald-700">
//                   <svg
//                     className="h-8 w-8"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2.5"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     aria-hidden="true"
//                   >
//                     <path d="M20 6L9 17l-5-5" />
//                   </svg>
//                 </div>
//               </div>

//               <p className="text-2xl font-semibold text-[#26A94A] mt-6">
//                 Payment Successful!
//               </p>
//               <p className="max-w-sm text-[#1465B7] font-semibold text-lg">
//                 Thanks for your purchase! Your files are ready to download. We’ll also email you the file once the download is complete..
//               </p>

//               <div className="mt-2 text-white">
//                 <button
//                   onClick={handleDownload}
//                   disabled={loadings}
//                   aria-busy={loadings ? 'true' : 'false'}
//                   className="inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-600 px-9 py-4 font-semibold text-[#1465B7] shadow transition
//                        hover:bg-emerald-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600 focus-visible:ring-offset-2
//                        disabled:opacity-70 disabled:cursor-not-allowed cursor-pointer"
//                 >
//                   {loadings && (
//                     <span
//                       className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent text-white"
//                       aria-hidden="true"
//                       style={{ color: 'white' }}
//                     />
//                   )}
//                   {loadings ? 'Preparing download…' : 'Download now'}
//                 </button>
//               </div>

//               {loadings && (
//                 <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800">
//                   <div className="h-full w-1/2 animate-pulse rounded-full bg-emerald-500"></div>
//                 </div>
//               )}

//             </div>
//           </div>
//         </div>
//       )}

//       <Modal
//         title="Terms & Conditions"
//         open={showTerms}
//         centered
//         onCancel={() => setShowTerms(false)}
//         footer={[
//           <div className="my-5 mx-5 gap-12" key="t1">
//             <Button key="agree" type="primary" onClick={handleAgree} className="!h-10 w-32 !rounded-full mr-12 text-base" style={{ marginRight: 30, backgroundColor: '#26A94A', fontSize: 16, fontWeight: 600 }}>
//               Agree
//             </Button>,
//             <Button key="cancel" onClick={() => setShowTerms(false)} className="!h-10 w-32 !rounded-full ml-12 bg-red-400" style={{ backgroundColor: 'red', color: 'white', fontSize: 16, fontWeight: 600 }}>
//               Cancel
//             </Button>,
//           </div>
//         ]}
//         width={720}
//       >
//         <div className="text-gray-700 text-base max-h-[28rem] overflow-y-auto thin-scroll">
//           <div className="p-5 text-left break-spaced">
//             <div className="text-left">
//               <p className="mb-3">Subscription Service Agreement</p>
//               <p className="mb-3">
//                 IMPORTANT: BY ACCESSING ANY PART OF THIS ONLINE SERVICE (THE “SERVICE”), YOU REPRESENT THAT YOU ARE EITHER AT LEAST EIGHTEEN (18) YEARS OLD OR HAVE YOUR PARENT’S OR GUARDIAN’S CONSENT TO REGISTER. YOU ALSO AGREE TO ALL TERMS AND CONDITIONS IN THIS SUBSCRIPTION SERVICE AGREEMENT (THE “AGREEMENT”). IF YOU DO NOT AGREE TO THESE TERMS OR CANNOT COMPLY WITH THEM, YOU MUST IMMEDIATELY STOP USING THE SERVICE.
//               </p>
//               <p className="mb-3">
//                 Any lists or data provided through the Service must be kept strictly confidential and may not be shared with third parties or used for purposes other than those expressly permitted by this Agreement. You may only use this data as part of your own marketing programs. Under no circumstances may any portion of the data — or any derived information — be sold, rented, licensed, sublicensed, or disclosed. You may not use this data to enhance or develop third-party databases, or to create competing products or services.
//               </p>
//               <p className="mb-3">
//                 Any marketing materials, solicitations, advertisements, or communications sent to individuals included in a list generated using this Service must not reference specific selection criteria, presumed recipient characteristics, or the source of the recipient’s inclusion — unless the information originates from data you yourself provided. You must comply with all applicable laws, regulations, and industry best practices in connection with any use of the data. You may not use the data for spam, chain letters, pyramid schemes, sexually explicit content, or other inappropriate purposes. Upon request, you must provide samples of mailings, scripts, ad copy, or other communications you plan to use.
//               </p>
//               <p className="mb-3">
//                 You will instruct any employees or third parties who have access to the data about the restrictions in this Agreement and ensure physical and logical security of the data at least to the level you protect your own sensitive information. Access shall not be granted to incarcerated persons or institutions.
//               </p>
//               <p className="mb-3">
//                 You will maintain accurate records related to your use of the data for at least twelve (12) months after each marketing communication. This includes financial details and a file of communications (e.g. sample mailings, scripts, ad materials). We reserve the right to review or copy such records with prior written notice (at least three business days), during normal business hours.
//               </p>
//               <p className="mb-3">
//                 By using or ordering the Service, you accept all terms of this Agreement without modification. Any attempt to accept on different terms is void.
//               </p>
//               <p className="mb-3"><strong>1. The Service</strong></p>
//               <p className="mb-3">
//                 The Service includes a web interface, marketing database, data encryption, data transmission, data access, and optionally synchronization software and storage. You are responsible for providing your own hardware, software, communications equipment, and paying any third-party access or network charges.
//               </p>
//               <p className="mb-3">
//                 The Service is provided without guarantee of uninterrupted availability or feature consistency. The provider reserves the right to change features or terms of this Agreement at any time without prior notice. All subscriptions run for twelve (12) consecutive months and may not be canceled before the end of that period. If you access or download data after your initial 12-month term, you agree to renew for another 12-month period.
//               </p>
//               <p className="mb-3"><strong>2. Use of Proprietary Software</strong></p>
//               <p className="mb-3">
//                 Subject to this Agreement, you are granted a personal, non-sublicensable, non-transferable, non-exclusive license to use proprietary software (in object code form) and any associated database solely in conjunction with the Service. You may not reverse engineer, decompile, translate, or create derivative works from the software, nor remove proprietary notices. You may not use it for time-sharing or service bureau purposes, or on behalf of third parties. Upon termination, this license ends and you must cease all use. The software and database are provided “as is,” subject to disclaimers and limitations in this Agreement.
//               </p>
//               <p className="mb-3"><strong>3. Restrictions and Policies</strong></p>
//               <p className="mb-3">
//                 You will not use the Service for spamming, chain letters, junk mail, illegal fax broadcasting, or contact lists of persons who have not given permission. You will not transmit content that is unlawful, harassing, abusive, threatening, obscene, or otherwise objectionable. You agree to defend and indemnify the provider against claims arising from your misuse of the Service. You must comply with all applicable laws including those governing copyright, trademark, defamation, and privacy.
//               </p>
//               <p className="mb-3">
//                 The provider respects customer privacy, but reserves the right to access or disclose content (e.g. data, files, messages) to comply with lawful requests, maintain operations, or protect itself or customers. You acknowledge that links to third-party sites or services may be provided, but the provider is not responsible for their content or availability.
//               </p>
//               <p className="mb-3"><strong>4. Support</strong></p>
//               <p className="mb-3">
//                 Unless specifically contracted for, no obligation is assumed to provide hard-copy documentation, upgrades, enhancements, or technical support (including phone support) under this Agreement.
//               </p>
//               <p className="mb-3"><strong>5. Payment of Fees</strong></p>
//               <p className="mb-3">
//                 You will supply accurate billing information (name, address, telephone) and update it as needed. Payment by fraudulent means may lead to immediate termination and legal action. You agree to pay the then-current fees for the Service in advance on a monthly basis. The provider reserves the right to change fees or institute new charges upon thirty (30) days’ notice.
//               </p>
//               <p className="mb-3">
//                 If your payment fails or account becomes delinquent, additional services may be suspended or removed. Restoration of archived data may incur additional fees. Any billing disputes must be raised within sixty (60) days of the first statement showing the error. Late invoices may accrue interest (e.g. 1.5% per month or as permitted by law) plus collection costs.
//               </p>
//               <p className="mb-3"><strong>6. Passwords and Security</strong></p>
//               <p className="mb-3">
//                 You are responsible for maintaining confidentiality of your login credentials. You are fully responsible for activity under your account. You must notify us immediately of any unauthorized use or breach. The provider is not liable for losses from your failure to secure your account.
//               </p>
//               <p className="mb-3"><strong>7. Termination</strong></p>
//               <p className="mb-3">
//                 This subscription automatically renews unless terminated by either party with thirty (30) days’ advance notice. The provider may terminate or suspend the Service immediately for breach. If terminated before the end of the twelve-month term, you remain liable for the remaining balance. Data may be deleted after 30 days of termination.
//               </p>
//               <p className="mb-3">
//                 On termination, you must cease all use of the software and data. Provisions that by nature should survive termination (e.g. confidentiality, liability, payment obligations) remain in effect. Use of other remedies does not affect termination rights.
//               </p>
//               <p className="mb-3"><strong>8. Warranty and Disclaimer</strong></p>
//               <p className="mb-3">
//                 THE SERVICE IS PROVIDED “AS IS” WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED — INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. If allowed by law, liability is limited to resupplying the Service. The provider does not guarantee uninterrupted operation, error-free function, or absence of harmful components. Any downloaded material is used at your own risk, and you bear responsibility for damages or data loss.
//               </p>
//               <p className="mb-3"><strong>9. Limitation of Liability</strong></p>
//               <p className="mb-3">
//                 THE TOTAL LIABILITY OF THE PROVIDER (IF ANY) WILL BE LIMITED TO THE FEES YOU PAID FOR THE SERVICE DURING THE PRIOR TWELVE (12) MONTHS. THE PROVIDER AND ITS LICENSORS WILL NOT BE LIABLE FOR INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS OR DATA, WHETHER FORESEEABLE OR NOT, EVEN IF ADVISED OF POSSIBILITY.
//               </p>
//               <p className="mb-3"><strong>10. Governing Law</strong></p>
//               <p className="mb-3">
//                 This Agreement is governed by the laws of the state of Nebraska, without regard to conflict of laws rules. You and the provider agree to submit to the exclusive jurisdiction of the courts in Douglas County, Nebraska. Any legal claim must be filed within one (1) year of the event that gave rise to it. This Agreement supersedes all prior agreements and communications, and may only be modified by a written document signed by both parties. Neither party may assign this Agreement without the other’s written consent. In any action to enforce rights hereunder, the prevailing party may recover costs and attorney’s fees. All notices hereunder must be in writing. Failure by either party to enforce any term does not constitute waiver unless agreed in writing. This Agreement and all related documents are drafted in English.
//               </p>
//             </div>
//           </div>
//         </div>
//       </Modal>

//       <Modal
//         title="Terms & Conditions"
//         open={downloadShowTerms}
//         centered
//         onCancel={() => setDownloadShowTerms(false)}
//         footer={[
//           <div className="my-5 mx-5 gap-12" key="t2">
//             <Button key="agree" type="primary" onClick={handleDownloadAgree} className="!h-10 w-32 !rounded-full mr-12 text-base" style={{ marginRight: 30, backgroundColor: '#26A94A', fontSize: 16, fontWeight: 600 }}>
//               Agree
//             </Button>,
//             <Button key="cancel" onClick={() => setDownloadShowTerms(false)} className="!h-10 w-32 !rounded-full ml-12 bg-red-400" style={{ backgroundColor: 'red', color: 'white', fontSize: 16, fontWeight: 600 }}>
//               Cancel
//             </Button>,
//           </div>
//         ]}
//         width={720}
//       >
//         <TermsAndCondition />
//       </Modal>

//     </div>
//   );
// }

// /* -------------------- Wrapper -------------------- */

// export default function StripeFinalCodeCheck({ hidePlanSelector = false }) {
//   const [stripePromise, setStripePromise] = useState(null);
//   // const [clientSecret, setClientSecret] = useState(null);
//   const { clientSecret } = useAppContext();
//   const [error, setError] = useState("");

//   useEffect(() => {
//     (async () => {
//       try {
//         const key = await fetchPublishableKeyIfNeeded();
//         if (!key || !key.startsWith("pk_"))
//           throw new Error("Invalid publishable key (must start with pk_)");
//         setStripePromise(loadStripe(key));
//       } catch (e) {
//         console.error(e);
//         setError(e?.message || "Failed to init Stripe.");
//       }
//     })();
//   }, []);

//   const appearance = {
//     theme: "stripe",
//   };

//   const options = {
//     clientSecret,
//     appearance,
//   };
//   return (
//     <div>
//       {error && (
//         <div className="mx-auto my-4 max-w-xl rounded-xl border border-red-200 bg-red-50 p-4 text-red-800">
//           <b>Configuration error</b>
//           <div className="mt-1 text-sm">{error}</div>
//         </div>
//       )}

//       {stripePromise && clientSecret && (
//         <Elements stripe={stripePromise} options={options} key={clientSecret}>
//           <PrettyForm hidePlanSelector={hidePlanSelector} />
//         </Elements>
//       )}
//     </div>
//   );
// }






import React, {
  useEffect,
  useRef,
  useState,
} from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  ExpressCheckoutElement,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { Lock, CreditCard, Shield } from "lucide-react";
import { useAppContext } from "../AppContext";
import { useNavigate, useLocation } from "react-router-dom";
import { getLangFromPath } from "../routes";
import axios from "axios";
import { Button, Modal } from "antd";
import TermsAndCondition from "./TermsAndCondition";
const API_BASE = "https://app.commercialcleaningleadsforyou.com";
// const API_BASE = "http://localhost:4242";

/** Shared across duplicate StripeFinalCodeCheck mounts (Header + SecondForm, Strict Mode). */
const zipCheckInflight = new Map(); // key -> Promise
const zipCheckDone = new Map(); // key -> { token, status, ok }
let rateLimitStatusPromise = null;

const PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

async function fetchPublishableKeyIfNeeded() {
  if (PUBLISHABLE_KEY) return PUBLISHABLE_KEY;
  const res = await fetch(`${API_BASE}/api/config`);
  if (!res.ok) throw new Error("Cannot reach /api/config.");
  const data = await res.json();
  if (!data.publishableKey)
    throw new Error("Server missing STRIPE_PUBLISHABLE_KEY.");
  return data.publishableKey;
}

/* -------------------- Main Form -------------------- */

const PAYMENT_STRINGS = {
  en: {
    paymentDetails: "Payment Details",
    securePayment: "Secure payment processing",
    subtotal: "Subtotal",
    totalAmount: "Total amount",
    choosePlan: "Choose which plan works best for you:",
    leads: "Leads",
    sendMeLeads: "Send me these leads around my zipcode:",
    checkingZipcodes: "Checking zipcodes…",
    zipcodesVerified: "Zipcodes verified.",
    zipcodeNotFound: "Zipcode details not found.",
    fullName: "Full Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    streetAddress: "Street Address",
    city: "City",
    state: "State",
    zipCode: "ZIP Code",
    placeholderZip: "12345",
    placeholderName: "John Doe",
    placeholderEmail: "you@example.com",
    placeholderPhone: "+1 (555) 123-4567",
    placeholderStreet: "123 Main St",
    placeholderCity: "City",
    placeholderState: "State",
    placeholderPostal: "ZIP",
    acceptTerms: "I've read and accept the",
    termsConditions: "Terms & Conditions",
    promoCode: "Promo Code",
    enterPromo: "Enter promo code",
    validating: "Validating...",
    apply: "Apply",
    validatingPromo: "Validating promo code...",
    promoApplied: "Promo code applied!",
    discount: "Discount",
    applied: "Applied",
    oneAttemptLeft: "You have one more attempt remaining.",
    attemptsLeftPlural: "You have %s more attempts remaining.",
    tooManyAttempts: "Too many failed attempts. Please try again later.",
    timeRemaining: "Time remaining:",
    processing: "Processing...",
    verifyingZipcodes: "Verifying zipcodes…",
    pay: "Pay",
    secureEncrypted: "Your payment details are securely encrypted",
    paymentSuccessful: "Payment Successful!",
    thanksPurchase: "Thanks for your purchase! Your files are ready to download. We'll also email you the file once the download is complete.",
    preparingDownload: "Preparing download…",
    downloadNow: "Download now",
    termsTitle: "Terms & Conditions",
    percentDiscount: "25% Discount",
    backToChangeZipEmail: "← Back to change ZIP or email",
  },
  es: {
    paymentDetails: "Datos del pago",
    securePayment: "Procesamiento de pago seguro",
    subtotal: "Subtotal",
    totalAmount: "Total",
    choosePlan: "Elige el plan que mejor te funcione:",
    leads: "Leads",
    sendMeLeads: "Envíame estos leads cerca de mi código postal:",
    checkingZipcodes: "Verificando códigos postales…",
    zipcodesVerified: "Códigos postales verificados.",
    zipcodeNotFound: "No se encontraron los códigos postales.",
    fullName: "Nombre completo",
    emailAddress: "Correo electrónico",
    phoneNumber: "Teléfono",
    streetAddress: "Dirección",
    city: "Ciudad",
    state: "Estado",
    zipCode: "Código postal",
    placeholderZip: "12345",
    placeholderName: "Juan Pérez",
    placeholderEmail: "tu@ejemplo.com",
    placeholderPhone: "+1 (555) 123-4567",
    placeholderStreet: "Calle Principal 123",
    placeholderCity: "Ciudad",
    placeholderState: "Estado",
    placeholderPostal: "CP",
    acceptTerms: "He leído y acepto los",
    termsConditions: "Términos y condiciones",
    promoCode: "Código promocional",
    enterPromo: "Ingresa el código promocional",
    validating: "Validando...",
    apply: "Aplicar",
    validatingPromo: "Validando código promocional...",
    promoApplied: "¡Código promocional aplicado!",
    discount: "Descuento",
    applied: "Aplicado",
    oneAttemptLeft: "Te queda un intento.",
    attemptsLeftPlural: "Te quedan %s intentos.",
    tooManyAttempts: "Demasiados intentos fallidos. Intenta más tarde.",
    timeRemaining: "Tiempo restante:",
    processing: "Procesando...",
    verifyingZipcodes: "Verificando códigos postales…",
    pay: "Pagar",
    secureEncrypted: "Tus datos de pago se cifran de forma segura",
    paymentSuccessful: "¡Pago exitoso!",
    thanksPurchase: "¡Gracias por tu compra! Tus archivos están listos para descargar. También te enviaremos el archivo por correo cuando se complete la descarga.",
    preparingDownload: "Preparando descarga…",
    downloadNow: "Descargar ahora",
    termsTitle: "Términos y condiciones",
    percentDiscount: "25% de descuento",
    backToChangeZipEmail: "← Volver a cambiar código postal o correo",
  },
};

function PrettyForm({ hidePlanSelector = false, lang = "en", stripePromise }) {
  const stripe = useStripe();
  const elements = useElements();
  const t = PAYMENT_STRINGS[lang] || PAYMENT_STRINGS.en;

  const {
    name, setName,
    email, setEmail,
    phone, setPhone,
    line1, setLine1,
    city, setCity,
    state, setState,
    postal, setPostal,
    zipcodes, setZipcodes,
    buyNow, setBuyNow,
    orderNumber, setOrderNumber,
    setClientSecret, clientSecret,
    selectedPrice, setSelectedPrice,
    leadsCount, setLeadsCount,
    preferredPaymentMethod,
    setPreferredPaymentMethod,
  } = useAppContext();

  const plans = [
    { qty: 50, price: 39 },
    { qty: 200, price: 99 },
    { qty: 500, price: 199 },
  ];

  const [toast, setToast] = useState({ open: false, text: "" });
  const [successOpen, setSuccessOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const cardRef = useRef(null);
  const paymentSectionRef = useRef(null);
  const [ready, setReady] = useState(false);

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [csvtoken, setCsvToken] = useState("");
  const [zipcodeError, setZipCodeError] = useState(false);
  const [paymentId, setPaymentId] = useState(null);
  const [accepted, setAccepted] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [downloadAccepted, setDownloadAccepted] = useState(false);
  const [downloadShowTerms, setDownloadShowTerms] = useState(false);
  const [hasAgreedToTerms, setHasAgreedToTerms] = useState(false); // Track if user clicked "Agree" in modal
  const navigate = useNavigate();

  // Promo code state
  const [promoCode, setPromoCode] = useState("");
  const [promoCodeValidating, setPromoCodeValidating] = useState(false);
  const [promoCodeValid, setPromoCodeValid] = useState(false);
  const [promoCodeError, setPromoCodeError] = useState("");
  const [promoCodeDiscount, setPromoCodeDiscount] = useState(0); // 0 to 1 (e.g., 0.25 = 25%)
  const [promoCodeApplied, setPromoCodeApplied] = useState(false);
  const [rateLimited, setRateLimited] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0); // in seconds
  const [remainingAttempts, setRemainingAttempts] = useState(5);

  // Discount state (UI only - no backend changes)
  const originalAmount = selectedPrice || 19900; // Use selected price from context, default to $199.00 in cents
  const discountPercent = promoCodeDiscount; // Use validated promo code discount
  const discountAmount = Math.round(originalAmount * discountPercent); // Discount in cents
  const discountedAmount = originalAmount - discountAmount; // Final amount after discount
  const isDiscountApplied = promoCodeApplied || hasAgreedToTerms; // Apply discount when promo code is valid OR user agrees to terms


  // NEW: zip check state
  const [zipCheckLoading, setZipCheckLoading] = useState(false);
  const [zipCheckOk, setZipCheckOk] = useState(null); // true | false | null
  const [zipCheckMsg, setZipCheckMsg] = useState("");
  const lastZipReqIdRef = useRef(0); // race-avoidance
  const zipDebounceRef = useRef(null);
  const lastCheckedKeyRef = useRef("");

  // NEW: zipcode check API (race-safe, deduped, awaitable)
  const zipcodeCheckAPI = async () => {
    const currentZip = (zipcodes || "").trim();
    const count = leadsCount || 50;
    const cacheKey = `${currentZip}|${count}`;

    if (!/^\d{5}$/.test(currentZip.replace(/\s/g, ""))) {
      // Allow comma lists still used in older flows, but prefer single 5-digit ZIP
      if (!/^[0-9,\s-]{5,100}$/.test(currentZip)) {
        setZipCodeError(true);
        setZipCheckOk(false);
        setZipCheckMsg("Please enter valid zipcode(s).");
        setCsvToken("");
        return { ok: false };
      }
    }

    // Reuse successful result for same zip + plan (no extra network call)
    const cached = zipCheckDone.get(cacheKey);
    if (cached?.ok && cached.token) {
      setCsvToken(cached.token);
      setData(cached.status);
      setZipCodeError(false);
      setZipCheckOk(true);
      setZipCheckMsg("Zipcodes verified.");
      setZipCheckLoading(false);
      lastCheckedKeyRef.current = cacheKey;
      return { ok: true };
    }

    const reqId = ++lastZipReqIdRef.current;
    setZipCheckLoading(true);
    setZipCodeError(false);
    setZipCheckOk(null);
    setZipCheckMsg("Checking…");

    try {
      let shared = zipCheckInflight.get(cacheKey);
      if (!shared) {
        shared = (async () => {
          const response = await fetch(`${API_BASE}/api/check-csv`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              zipcode: currentZip,
              leads_count: count,
            }),
          });
          if (!response.ok) {
            return { ok: false, token: "", status: false };
          }
          const result = await response.json();
          const ok = Boolean(result?.token);
          return {
            ok,
            token: result?.token || "",
            status: result?.status,
          };
        })().finally(() => {
          zipCheckInflight.delete(cacheKey);
        });
        zipCheckInflight.set(cacheKey, shared);
      }

      const result = await shared;
      if (reqId !== lastZipReqIdRef.current) return { ok: false, ignored: true };

      if (result.ok) {
        zipCheckDone.set(cacheKey, result);
        lastCheckedKeyRef.current = cacheKey;
      } else {
        zipCheckDone.delete(cacheKey);
      }

      setCsvToken(result.token || "");
      setData(result.status);
      setZipCodeError(!result.ok);
      setZipCheckOk(result.ok);
      setZipCheckMsg(result.ok ? "Zipcodes verified." : "Zipcode details not found.");
      return { ok: result.ok };
    } catch (err) {
      if (reqId !== lastZipReqIdRef.current) return { ok: false, ignored: true };
      setZipCodeError(true);
      setZipCheckOk(false);
      setZipCheckMsg("Could not verify zipcodes. Try again.");
      setCsvToken("");
      return { ok: false };
    } finally {
      if (reqId === lastZipReqIdRef.current) {
        setZipCheckLoading(false);
      }
    }
  };

  // Debounced check — only when ZIP/plan actually change; skip duplicate keys
  useEffect(() => {
    const currentZip = (zipcodes || "").trim();
    const count = leadsCount || 50;
    const cacheKey = `${currentZip}|${count}`;

    if (zipDebounceRef.current) {
      clearTimeout(zipDebounceRef.current);
      zipDebounceRef.current = null;
    }

    if (currentZip.length < 5) {
      setZipCheckLoading(false);
      setZipCheckOk(null);
      setZipCodeError(false);
      setZipCheckMsg("");
      setCsvToken("");
      lastCheckedKeyRef.current = "";
      return;
    }

    if (lastCheckedKeyRef.current === cacheKey && zipCheckDone.get(cacheKey)?.ok) {
      const cached = zipCheckDone.get(cacheKey);
      setCsvToken(cached.token || "");
      setZipCheckOk(true);
      setZipCodeError(false);
      setZipCheckMsg("Zipcodes verified.");
      setZipCheckLoading(false);
      return;
    }

    zipDebounceRef.current = setTimeout(() => {
      zipcodeCheckAPI();
    }, 450);

    return () => {
      if (zipDebounceRef.current) {
        clearTimeout(zipDebounceRef.current);
        zipDebounceRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zipcodes, leadsCount]);

  // true once ExpressCheckoutElement reports at least one available wallet
  const [expressReady, setExpressReady] = useState(false);

  // Rate limit timer for UI updates
  const rateLimitTimerRef = useRef(null);

  useEffect(() => {
    if (!toast.open) return;
    const t = setTimeout(() => setToast({ open: false, text: "" }), 6000);
    return () => clearTimeout(t);
  }, [toast.open]);

  // Helper function to calculate remaining time from expiration timestamp
  const calculateRemainingTime = (expiresAt) => {
    if (!expiresAt) return 0;
    const now = Date.now();
    const remaining = Math.max(0, Math.ceil((expiresAt - now) / 1000));
    return remaining;
  };

  // Helper function to start countdown timer
  const startCountdownTimer = (expiresAt) => {
    if (rateLimitTimerRef.current) {
      clearInterval(rateLimitTimerRef.current);
    }

    const updateRemainingTime = () => {
      const remaining = calculateRemainingTime(expiresAt);
      setRemainingTime(remaining);

      if (remaining <= 0) {
        clearInterval(rateLimitTimerRef.current);
        setRateLimited(false);
        setRemainingTime(0);
        // Clear from localStorage
        localStorage.removeItem('promoRateLimitExpiresAt');
      }
    };

    // Update immediately
    updateRemainingTime();

    // Update every second
    rateLimitTimerRef.current = setInterval(updateRemainingTime, 1000);
  };

  // Restore rate limit state from localStorage and backend on mount
  useEffect(() => {
    const restoreRateLimitState = async () => {
      try {
        // First check localStorage for cached expiration
        const cachedExpiresAt = localStorage.getItem('promoRateLimitExpiresAt');
        if (cachedExpiresAt) {
          const expiresAt = parseInt(cachedExpiresAt, 10);
          const remaining = calculateRemainingTime(expiresAt);

          if (remaining > 0) {
            // Still rate limited, restore from cache
            setRateLimited(true);
            setRemainingTime(remaining);
            startCountdownTimer(expiresAt);
            return; // Use cached data, no need to query backend
          } else {
            // Expired, clear cache
            localStorage.removeItem('promoRateLimitExpiresAt');
          }
        }

        // Query backend for current status (shared — Strict Mode / multi-mount safe)
        if (!rateLimitStatusPromise) {
          rateLimitStatusPromise = fetch(`${API_BASE}/api/check-rate-limit-status`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          })
            .then(async (response) => {
              if (!response.ok) return null;
              return response.json();
            })
            .catch(() => null)
            .finally(() => {
              // Allow a later refresh after this tick completes
              setTimeout(() => {
                rateLimitStatusPromise = null;
              }, 5000);
            });
        }
        const data = await rateLimitStatusPromise;

        if (data?.blocked && data.expiresAt) {
          const expiresAt = data.expiresAt;
          const remaining = calculateRemainingTime(expiresAt);

          if (remaining > 0) {
            setRateLimited(true);
            setRemainingTime(remaining);
            localStorage.setItem("promoRateLimitExpiresAt", expiresAt.toString());
            startCountdownTimer(expiresAt);
          } else {
            setRateLimited(false);
            setRemainingTime(0);
            localStorage.removeItem("promoRateLimitExpiresAt");
          }
        } else {
          setRateLimited(false);
          setRemainingTime(0);
          localStorage.removeItem("promoRateLimitExpiresAt");
        }

        if (data && !data.blocked) {
          setRemainingAttempts(data.remainingAttempts || 5);
        }
      } catch (error) {
        console.error("Error checking rate limit status:", error);
        // On error, try to use localStorage if available
        const cachedExpiresAt = localStorage.getItem('promoRateLimitExpiresAt');
        if (cachedExpiresAt) {
          const expiresAt = parseInt(cachedExpiresAt, 10);
          const remaining = calculateRemainingTime(expiresAt);
          if (remaining > 0) {
            setRateLimited(true);
            setRemainingTime(remaining);
            startCountdownTimer(expiresAt);
          }
        }
      }
    };

    restoreRateLimitState();

    // Cleanup on unmount
    return () => {
      if (rateLimitTimerRef.current) {
        clearInterval(rateLimitTimerRef.current);
      }
    };
  }, []); // Only run on mount

  const showError = (msg) => setToast({ open: true, text: msg });
  const closeError = () => setToast({ open: false, text: "" });

  const validatePersonal = () => {
    if (!name || !email || !line1 || !city || !state || !postal) {
      showError("Please complete all required personal details.");
      return false;
    }
    return true;
  };

  const [loadings, setLoadings] = useState(false);
  const [message, setMessage] = useState("");

  const getFilenameFromHeaders = (resp) => {
    const cd = resp.headers.get("content-disposition");
    if (!cd) return null;
    const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd);
    return decodeURIComponent(m?.[1] || m?.[2] || "");
  };

  const [ip, setIp] = useState();

  useEffect(() => {
    const getIpDetails = async () => {
      try {
        const response = await axios.get("https://ipinfo.io/json");
        setIp(response.data);
      } catch (error) {
        console.error("Error fetching IP details:", error);
      }
    };

    getIpDetails();
  }, []);

  async function postDownloadStatus(paymentId, status) {
    if (!paymentId) return;
    try {
      await fetch(`${API_BASE}/api/update-download-status`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ paymentId, downloadStatus: status }),
      });
    } catch (e) {
      console.warn("update-download-status failed:", e);
    }
  }

  // When user chose Apple Pay / Google Pay / PayPal / Amazon from preview, scroll to payment section.
  // For Apple/Google Pay the backend restricts to wallet-only (no card), so no tab click needed.
  // For PayPal/Amazon we try to activate that tab so the right method is selected.
  useEffect(() => {
    if (!preferredPaymentMethod) return;
    const method = preferredPaymentMethod;
    const isWalletOnly = method === "apple" || method === "google";

    const scrollAndActivate = () => {
      paymentSectionRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      if (isWalletOnly) return; // PaymentElement shows only Apple/Google Pay; preferred is first
      const tryClickTab = () => {
        const container = paymentSectionRef.current;
        if (!container) return;
        const tabs = container.querySelectorAll('[role="tab"], button[class*="Tab"], .p-Tab, [data-testid*="tab"]');
        for (const tab of tabs) {
          const text = (tab.textContent || "").toLowerCase();
          if ((method === "paypal" && text.includes("paypal")) || (method === "amazon" && text.includes("amazon"))) {
            tab.click();
            break;
          }
        }
      };
      setTimeout(tryClickTab, 800);
      setTimeout(tryClickTab, 1600);
    };
    const t = setTimeout(scrollAndActivate, 300);
    return () => clearTimeout(t);
  }, [preferredPaymentMethod]);

  const handleDownload = async (e) => {
    e.preventDefault();

    // NEW: gate download by zipcode check
    if (zipCheckLoading) {
      alert("We’re still verifying your zipcodes. Please wait a moment.");
      return;
    }
    if (!csvtoken) {
      const finalCheck = await zipcodeCheckAPI();
      if (!finalCheck?.ok) {
        alert(zipCheckMsg || "Zipcode verification failed. Please review and try again.");
        return;
      }
    }

    if (!/^[0-9,\s-]{3,100}$/.test(zipcodes)) {
      alert("Please enter valid zipcode(s).");
      return;
    }

    setLoadings?.(true);

    // ensure we only post one status
    let statusPosted = false;
    const postOnce = async (status) => {
      if (statusPosted) return;
      statusPosted = true;
      await postDownloadStatus(paymentId, status);
    };

    try {
      const resp = await fetch(`${API_BASE}/api/download-csv`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          zipcode: zipcodes,
          token: csvtoken,
          email,
          orderno: orderNumber,
          paymentId: paymentId,
          leads_count: leadsCount || 50
        }),
      });

      if (!resp.ok) {
        await postOnce("No");
        const text = await resp.text();
        let message = text;
        try { message = JSON.parse(text).error || message; } catch { }
        throw new Error(message || `Request failed: ${resp.status}`);
      }

      // 200 OK → immediately mark as Yes
      await postOnce("Yes");

      // Then download the CSV
      const blob = await resp.blob();
      const url = URL.createObjectURL(blob);
      const filename =
        getFilenameFromHeaders(resp) || `${zipcodes.replace(/[^\d, -]/g, "")}.csv`;

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);

      setCity?.("");
      setLine1?.("");
      setPhone?.("");
      setPostal?.("");
      setState?.("");
      setName?.("");
      setSuccessOpen?.(false);
      navigate('/thank-you')

    } catch (err) {
      console.error(err);
      await postOnce("No");
      alert("Error downloading file");
    } finally {
      setLoadings?.(false);
    }
  };

  function ErrorToast({ open, text, onClose }) {
    if (!open) return null;
    return (
      <div className="fixed z-50 bottom-6 inset-x-0 px-4">
        <div className="mx-auto max-w-md">
          <div className="flex items-center justify-between rounded-xl bg-gradient-to-r from-red-500 to-rose-600 text-white shadow-lg px-4 py-3">
            <div className="flex items-center">
              <span className="mr-3 text-xl">⚠️</span>
              <div className="font-medium">{text}</div>
            </div>
            <button onClick={onClose} className="text-white/90 hover:text-white">
              ✕
            </button>
          </div>
        </div>
      </div>
    );
  }

  function SuccessModal({ open, text, onClose }) {
    const navigate = useNavigate();
    const handleContinue = () => {
      if (onClose) onClose();
      navigate("/");
    };
    const handleClose = () => {
      setSuccessOpen(false);
    };
    if (!open) return null;
    return (
      <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
        <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl p-6 text-center">
          <div className="mx-auto w-14 h-14 rounded-full bg-green-100 flex items-center justify-center mb-4">
            <span className="text-2xl">✔</span>
          </div>
          <h3 className="text-xl font-semibold text-gray-800">
            Payment Successful!
          </h3>
          <p className="text-gray-500 mt-2">
            {text || "Your payment was completed successfully."}
          </p>
          <button
            onClick={handleDownload}
            disabled={loadings}
            className="mt-6 inline-flex items-center justify-center rounded-xl bg-[#26A94A] px-5 py-3 text-white font-semibold hover:from-indigo-700 hover:to-purple-700 shadow cursor-pointer"
          >
            {loadings ? 'Downloading…' : `Download`}
          </button>
        </div>
      </div>
    );
  }

  const [baseAmount, setBaseAmount] = useState(selectedPrice || 19900); // Use selected price from context, default to $199.00 in cents
  const [finalAmount, setFinalAmount] = useState(baseAmount);

  const handleConfirmPayment = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    let createdPaymentId = null;
    let failureRecorded = false;

    const recordFailure = async ({ reason, paymentIntentId = null, status = "failed" }) => {
      if (!createdPaymentId || failureRecorded) return;
      failureRecorded = true;
      try {
        await fetch(`${API_BASE}/api/record-payment-failure`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            paymentId: createdPaymentId,
            paymentIntentId,
            reason,
            status,
          }),
        });
      } catch { /* non-blocking */ }
    };

    // NEW: block while checking
    if (zipCheckLoading) {
      showError("We're still verifying your zipcodes. Please wait a moment.");
      return;
    }

    // NEW: force final check if user clicked fast
    if (!csvtoken) {
      const finalCheck = await zipcodeCheckAPI();
      if (!finalCheck?.ok) {
        showError(zipCheckMsg || "Zipcode verification failed. Please review and try again.");
        return;
      }
    }

    // Safety net
    if (zipcodeError || zipCheckOk === false) {
      showError(zipCheckMsg || "Zipcode details not found.");
      return;
    }

    const submitResult = await elements.submit();
    if (submitResult?.error) {
      showError(submitResult.error.message);
      return;
    }

    if (!validatePersonal()) return;

    setSubmitting(true);
    try {
      // Generate order number in US timezone
      const usDate = new Date().toLocaleString("en-US", {
        timeZone: "America/Chicago",
      });

      const now = new Date(usDate);
      const pad = (n) => n.toString().padStart(2, "0");

      const year = now.getFullYear();
      const month = pad(now.getMonth() + 1);
      const day = pad(now.getDate());
      const hours = pad(now.getHours());
      const minutes = pad(now.getMinutes());
      const seconds = pad(now.getSeconds());

      const orderno = `${year}${month}${day}${hours}${minutes}${seconds}`;
      setOrderNumber(orderno);

      const finalAmount = isDiscountApplied ? discountedAmount : originalAmount;

      // Extract paymentIntentId from clientSecret (format: pi_xxx_secret_xxx)
      let paymentIntentId = null;
      let currentClientSecret = clientSecret; // Track the current clientSecret
      if (clientSecret) {
        const parts = clientSecret.split('_secret_');
        if (parts.length === 2) {
          paymentIntentId = parts[0];
        }
      }

      // CRITICAL: Update PaymentIntent amount BEFORE creating payment record
      // This ensures the PaymentIntent has the correct discounted amount when we confirm payment
      // Note: This should already be updated when promo code was validated, but do a final check
      if (isDiscountApplied && paymentIntentId && finalAmount !== originalAmount) {
        try {
          const updateRes = await fetch(`${API_BASE}/api/update-payment-intent-amount`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              paymentIntentId: paymentIntentId,
              amount: finalAmount
            }),
          });

          const updateData = await updateRes.json();
          // Check if the update was successful
          if (!updateRes.ok) {
            throw new Error(updateData?.error || "Failed to update payment amount");
          }
          // If backend returns success field, check it; otherwise assume success if status is OK
          if (updateData.success === false) {
            throw new Error(updateData?.error || "Failed to update payment amount");
          }

          // If backend returns a new clientSecret, update it (though usually it stays the same)
          if (updateData.clientSecret) {
            currentClientSecret = updateData.clientSecret;
            setClientSecret(updateData.clientSecret);
            // Wait for React to re-render and Elements to potentially remount
            await new Promise(resolve => setTimeout(resolve, 300));
          }
        } catch (updateErr) {
          console.error("Error updating payment intent amount:", updateErr);
          throw new Error(`Failed to apply discount: ${updateErr.message}`);
        }
      }

      // Now create the payment record with the correct amount
      // Pass paymentIntentId so backend knows which PaymentIntent to use
      const createRes = await fetch(`${API_BASE}/api/create-payment-onetime`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          name,
          amount: finalAmount, // Use discounted amount if promo code is applied
          originalAmount: originalAmount, // Add the original amount before discount
          couponApplied: promoCodeApplied, // Boolean indicating if promo code is applied
          discountPercentage: Math.round(promoCodeDiscount * 100), // The discount percentage
          promoCode: promoCodeApplied ? promoCode.trim().toUpperCase() : null, // Promo code used
          currency: "usd",
          glsZipCode: zipcodes,
          phone,
          address: line1,
          city,
          state,
          zipcode: postal,
          user_city: ip?.city,
          user_postal: ip?.postal,
          user_region: ip?.region,
          user_loc: ip?.loc,
          user_ip: ip?.ip,
          orderno,
          paymentIntentId: paymentIntentId, // Pass paymentIntentId so backend can link/update it
          leads_count: leadsCount || 50,
        }),
      });
      const createData = await createRes.json().catch(() => null);
      if (!createRes.ok || !createData?.paymentId)
        throw new Error(createData?.error || "Payment creation failed");

      const paymentId = createData.paymentId;
      createdPaymentId = paymentId;
      setPaymentId(paymentId);

      // If backend returns a new clientSecret (e.g., if it created a new PaymentIntent), update it
      if (createData.clientSecret && createData.clientSecret !== currentClientSecret) {
        setClientSecret(createData.clientSecret);
        // Wait for Elements to re-initialize with new PaymentIntent
        await new Promise(resolve => setTimeout(resolve, 500));
        // Note: At this point, elements might be stale, but confirmPayment should handle this
        // by using the clientSecret from Elements' configuration
      }

      // Confirm payment - Stripe will use the PaymentIntent associated with the elements
      // Since we updated the PaymentIntent amount above, it should charge the discounted amount
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: { receipt_email: email },
        redirect: "if_required",
      });

      if (error) {
        await recordFailure({
          reason: error.message,
          paymentIntentId: error.payment_intent?.id || paymentIntent?.id || null,
          status: error.payment_intent?.status || "failed",
        });
        throw new Error(error.message);
      }
      if (paymentIntent?.status !== "succeeded") {
        await recordFailure({
          reason: `Payment not completed (status: ${paymentIntent?.status}).`,
          paymentIntentId: paymentIntent?.id || null,
          status: paymentIntent?.status || "failed",
        });
        throw new Error(`Payment not completed (status: ${paymentIntent?.status}).`);
      }

      await fetch(`${API_BASE}/api/sync-payment-intent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ paymentIntentId: paymentIntent.id, paymentId }),
      });

      setBuyNow("download");
    } catch (err) {
      await recordFailure({ reason: err?.message || "Something went wrong.", status: "failed" });
      showError(err?.message || "Something went wrong.");
    } finally {
      setSubmitting(false);
    }
  };


  // Validate promo code
  const validatePromoCode = async (code) => {
    if (!code || code.trim() === "") {
      setPromoCodeValid(false);
      setPromoCodeApplied(false);
      setPromoCodeDiscount(0);
      setPromoCodeError("");
      setRateLimited(false);
      return;
    }

    setPromoCodeValidating(true);
    setPromoCodeError("");
    setRateLimited(false);

    try {
      const response = await fetch(`${API_BASE}/api/validate-promo-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ promoCode: code.trim() }),
      });

      const data = await response.json();

      if (data.valid) {
        // Valid promo code
        setPromoCodeValid(true);
        setPromoCodeApplied(true);
        setPromoCodeDiscount(data.discount);
        setPromoCodeError("");
        setRateLimited(false);
        setRemainingTime(0);
        // Clear rate limit from localStorage when promo code is valid
        localStorage.removeItem('promoRateLimitExpiresAt');
        if (rateLimitTimerRef.current) {
          clearInterval(rateLimitTimerRef.current);
        }

        // Update payment intent amount if available
        await updatePaymentIntentWithDiscount(data.discount);
      } else {
        // Invalid promo code or rate limited
        setPromoCodeValid(false);
        setPromoCodeApplied(false);
        setPromoCodeDiscount(0);
        setPromoCodeError(data.message || data.error || "Invalid promo code");

        if (data.rateLimited && data.expiresAt) {
          // Rate limited - store expiration timestamp and start countdown
          const expiresAt = data.expiresAt;
          setRateLimited(true);
          localStorage.setItem('promoRateLimitExpiresAt', expiresAt.toString());
          startCountdownTimer(expiresAt);
        } else {
          setRateLimited(false);
          setRemainingTime(0);
          setRemainingAttempts(data.remainingAttempts || 5);
        }

        // Update payment intent to remove discount
        await updatePaymentIntentWithDiscount(0);
      }
    } catch (error) {
      console.error("Error validating promo code:", error);
      setPromoCodeValid(false);
      setPromoCodeApplied(false);
      setPromoCodeDiscount(0);
      setPromoCodeError("Failed to validate promo code. Please try again.");
      await updatePaymentIntentWithDiscount(0);
    } finally {
      setPromoCodeValidating(false);
    }
  };

  // Update payment intent with discount
  const updatePaymentIntentWithDiscount = async (discountPercent) => {
    let paymentIntentId = null;
    if (clientSecret) {
      const parts = clientSecret.split('_secret_');
      if (parts.length === 2) {
        paymentIntentId = parts[0];
      }
    }

    if (!paymentIntentId) return;

    const currentBaseAmount = selectedPrice || 19900;
    const discountedAmount = Math.round(currentBaseAmount * (1 - discountPercent));

    try {
      const updateRes = await fetch(`${API_BASE}/api/update-payment-intent-amount`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          paymentIntentId: paymentIntentId,
          amount: discountedAmount
        }),
      });

      const updateData = await updateRes.json();
      if (!updateRes.ok) {
        throw new Error(updateData?.error || "Failed to update payment amount");
      }
      if (updateData.success === false) {
        throw new Error(updateData?.error || "Failed to update payment amount");
      }

      if (updateData.clientSecret) {
        setClientSecret(updateData.clientSecret);
      }
    } catch (error) {
      console.error("Error updating payment amount:", error);
    }
  };

  // Handle promo code input change
  const handlePromoCodeChange = async (value) => {
    setPromoCode(value);
    // Clear validation state when user types
    if (value.trim() === "") {
      setPromoCodeValid(false);
      setPromoCodeApplied(false);
      setPromoCodeDiscount(0);
      setPromoCodeError("");
      setRateLimited(false);
      // Reset payment intent to original amount when promo code is cleared
      await updatePaymentIntentWithDiscount(0);
    }
  };

  // Handle promo code validation on blur or Enter key
  const handlePromoCodeSubmit = () => {
    if (promoCode.trim()) {
      validatePromoCode(promoCode);
    }
  };


  useEffect(() => {
    const price = selectedPrice || 19900;
    setBaseAmount(price);
    const discount = promoCodeApplied ? promoCodeDiscount : 0;
    setFinalAmount(Math.round(price * (1 - discount)));
  }, [promoCodeApplied, promoCodeDiscount, selectedPrice]);
  const handleAgree = () => {
    setAccepted(true);
    setHasAgreedToTerms(true); // Apply discount after agreeing to terms
    setShowTerms(false);
  };

  const handleDownloadAgree = () => {
    setDownloadAccepted(true);
    setDownloadShowTerms(false);
  };

  return (
    <div>
      <ErrorToast open={toast.open} text={toast.text} onClose={closeError} />
      <SuccessModal
        open={successOpen}
        text="Please check the mail for detailed report"
        onClose={() => handleClose()}
      />

      {buyNow === 'payment' && (
        <div className="max-w-xl mx-auto mb-8">
          <div className="shadow-2xl border-6 border-[#26A94A] rounded-2xl overflow-hidden bg-white/80 backdrop-blur-sm">
            <div className="bg-[#26A94A] p-4 text-white">
              {/* <button
                type="button"
                onClick={() => setBuyNow("form")}
                className="mb-3 w-full text-left text-sm text-white/90 hover:text-white underline focus:outline-none focus:ring-2 focus:ring-white/50 rounded"
              >
                {t.backToChangeZipEmail}
              </button> */}
              <div className="flex justify-between items-center">
                <div className="w-[50%]">
                  <h2 className="text-xl font-bold">{t.paymentDetails}</h2>
                  <p className="text-indigo-100">{t.securePayment}</p>
                </div>
                <Shield className="h-10 w-10 text-white/80 " />
              </div>
              <div className="mt-2 bg-[#cccc4b] rounded-xl p-4 backdrop-blur-sm">
                <div className="space-y-2">
                  <div className="flex justify-between items-center">
                    <div>
                      <div className="text-[#1465B7] text-lg">{t.subtotal}</div>
                      <div className="text-[#1465B7] text-2xl font-bold">${(originalAmount / 100).toFixed(2)}</div>
                    </div>
                    <CreditCard className="h-8 w-8 text-[#1465B7]" />
                  </div>
                  {isDiscountApplied && (
                    <div className="pt-2 border-t border-[#1465B7]/20">
                      <div className="flex justify-between items-center text-[#1465B7]">
                        <div className="flex items-center gap-2">
                          <span className="text-sm font-medium">
                            {promoCodeApplied
                              ? `${Math.round(promoCodeDiscount * 100)}% ${t.discount}${promoCode ? ` (${promoCode.trim().toUpperCase()})` : ''}`
                              : t.percentDiscount}
                          </span>
                          <span className="text-xs bg-green-500 text-white px-2 py-0.5 rounded-full font-semibold">{t.applied}</span>
                        </div>
                        <div className="text-lg font-semibold">-${(discountAmount / 100).toFixed(2)}</div>
                      </div>
                    </div>
                  )}
                  <div className="pt-2 border-t-2 border-[#1465B7]/30">
                    <div className="flex justify-between items-center">
                      <div className="text-[#1465B7] text-lg font-semibold">{t.totalAmount}</div>
                      <div className="text-[#1465B7] text-2xl font-bold">
                        ${((isDiscountApplied ? discountedAmount : originalAmount) / 100).toFixed(2)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-6">
              <form onSubmit={handleConfirmPayment}>
                <div className="space-y-5">
                  <div className="space-y-4">
                    {!hidePlanSelector && <div className="space-y-2">
                      <label className="text-md text-gray-700 font-medium mb-2 block text-center">
                        {t.choosePlan}
                      </label>

                      {/* 50 / 200 / 500 Leads row */}
                      <div className="flex justify-center mb-6">
                        <div
                          className="
                  w-full max-w-sm
                  bg-[#BFEAF2]
                  border-[3px] border-[#26A94A]
                  rounded-xl
                  overflow-hidden
                  grid grid-cols-3
                "
                        >
                          {plans.map((p, idx) => (
                            <button
                              key={p.qty}
                              type="button"
                              onClick={() => {
                                setLeadsCount(p.qty);
                                setSelectedPrice(p.price * 100);
                              }}
                              className={`
                      py-2
                      flex flex-col items-center justify-center
                      transition
                      cursor-pointer
                      ${idx !== 0 ? "border-l-[3px] border-[#26A94A]" : ""}
                      ${leadsCount === p.qty ? "bg-[#85C1CF]" : ""}
                    `}
                            >
                              <span
                                className="
                        text-lg sm:text-xl 
                        font-extrabold leading-none
                        text-[#26A94A]
                        drop-shadow-[1px_1px_0px_#FFFFFF]
                      "
                              >
                                {p.qty}
                              </span>
                              <span className="text-sm font-extrabold leading-none text-[#1465B7]">
                                {t.leads}
                              </span>
                              <span className="text-sm font-extrabold leading-none text-[#26A94A] my-1">
                                ${p.price}
                              </span>
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>}

                    <div className="space-y-2">
                      <label className="text-md text-gray-700 font-medium">
                        {t.sendMeLeads}
                      </label>
                      <div className="w-full flex justify-center items-center mt-2">
                        <input
                          value={zipcodes}
                          onChange={(e) => setZipcodes(e.target.value)}
                          placeholder={t.placeholderZip}
                          className="py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500 mx-auto max-w-md"
                        />
                      </div>

                      {/* Inline status line */}
                      {(zipcodes?.trim()?.length >= 5) && (
                        <div className="mt-2 text-center">
                          {zipCheckLoading && <p className="text-sm text-gray-500">{t.checkingZipcodes}</p>}
                          {!zipCheckLoading && zipCheckOk === true && (
                            <p className="text-sm text-green-600">{t.zipcodesVerified}</p>
                          )}
                          {!zipCheckLoading && zipCheckOk === false && (
                            <p className="text-sm text-red-500">{zipCheckMsg || t.zipcodeNotFound}</p>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">
                          {t.fullName} <span className="text-red-600">*</span>
                        </label>
                        <input
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          placeholder={t.placeholderName}
                          autoComplete="name"
                          required
                          className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">
                          {t.emailAddress} <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder={t.placeholderEmail}
                          autoComplete="email"
                          required
                          className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">
                          {t.phoneNumber} <span className="text-red-600">*</span>
                        </label>
                        <input
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          placeholder={t.placeholderPhone}
                          inputMode="tel"
                          autoComplete="tel"
                          required
                          className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">
                          {t.streetAddress} <span className="text-red-600">*</span>
                        </label>
                        <input
                          value={line1}
                          onChange={(e) => setLine1(e.target.value)}
                          placeholder={t.placeholderStreet}
                          autoComplete="address-line1"
                          required
                          className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-4">
                      <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">
                          {t.city} <span className="text-red-600">*</span>
                        </label>
                        <input
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                          placeholder={t.placeholderCity}
                          autoComplete="address-level2"
                          required
                          className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">
                          {t.state} <span className="text-red-600">*</span>
                        </label>
                        <input
                          value={state}
                          onChange={(e) => setState(e.target.value)}
                          placeholder={t.placeholderState}
                          autoComplete="address-level1"
                          required
                          className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">
                          {t.zipCode} <span className="text-red-600">*</span>
                        </label>
                        <input
                          value={postal}
                          onChange={(e) => setPostal(e.target.value)}
                          placeholder={t.placeholderPostal}
                          inputMode="numeric"
                          autoComplete="postal-code"
                          required
                          className="w-full py-3 px-3 text-base border rounded-xl outline-none border-gray-300 focus:border-indigo-500"
                        />
                      </div>
                    </div>

                    <div ref={paymentSectionRef} className="space-y-3 min-h-[320px]">
                      {/* ── Express Checkout: Google Pay / Apple Pay / PayPal ──
                          Clicking a wallet button runs the full payment without
                          the card form below. The card form is used only when
                          the user fills it in and clicks the Pay button. ── */}
                      {/* {stripePromise && clientSecret && (
                        <Elements
                          stripe={stripePromise}
                          options={{ clientSecret, appearance: { theme: "stripe" } }}
                          key={`express-${clientSecret}`}
                        >
                          <ExpressCheckoutInner onExpressReady={setExpressReady} />
                        </Elements>
                      )} */}

                      {/* Only show divider when wallet buttons actually rendered */}
                      {/* {expressReady && (
                        <div className="flex items-center gap-2">
                          <hr className="flex-1 border-gray-200" />
                          <span className="text-xs text-gray-400">or pay with card / BNPL</span>
                          <hr className="flex-1 border-gray-200" />
                        </div>
                      )} */}

                      {/* ── Regular card / BNPL tabs (affirm, klarna, afterpay, etc.) ──
                          These show only when the user has NOT clicked a wallet button.
                          All account-enabled methods appear here via automatic_payment_methods. ── */}
                      <div className="border rounded-xl p-3 min-h-[220px] bg-white visibility-visible">
                        <PaymentElement
                          options={{
                            layout: {
                              type: "accordion",
                              defaultCollapsed: false,
                              radios: true,
                              spacedAccordionItems: true,
                            },
                          }}
                        />
                      </div>
                    </div>

                    <div className="flex items-center gap-3 ml-1">
                      <input
                        id="accept"
                        type="checkbox"
                        checked={accepted}
                        onChange={(e) => setAccepted(e.target.checked)}
                        className="mt-2 h-4 w-4 cursor-pointer rounded border-slate-600 bg-slate-900 text-indigo-600 focus:ring-indigo-500"
                        aria-describedby="terms-help"
                      />
                      <label htmlFor="accept" className="text-sm text-gray-700 leading-relaxed">
                        {t.acceptTerms}{" "}
                        <button
                          type="button"
                          className="font-medium underline-offset-2 underline cursor-pointer"
                          onClick={() => setShowTerms(true)}
                          aria-label={t.termsConditions}
                          style={{ color: 'blue' }}
                        >
                          {t.termsConditions}
                        </button>
                      </label>
                    </div>
                    {/* Promo Code Input */}
                    <div className="mt-4">
                      <label htmlFor="promoCode" className="block text-sm font-medium text-gray-700 mb-2">
                        {t.promoCode}
                      </label>
                      <div className="flex gap-2">
                        <input
                          id="promoCode"
                          type="text"
                          value={promoCode}
                          onChange={(e) => handlePromoCodeChange(e.target.value)}
                          onBlur={handlePromoCodeSubmit}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handlePromoCodeSubmit();
                            }
                          }}
                          placeholder={t.enterPromo}
                          disabled={promoCodeValidating || rateLimited}
                          className={`flex-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${promoCodeValid
                            ? "border-green-500 focus:ring-green-500"
                            : promoCodeError
                              ? "border-red-500 focus:ring-red-500"
                              : "border-gray-300 focus:ring-indigo-500"
                            } disabled:opacity-50 disabled:cursor-not-allowed`}
                          aria-describedby="promo-code-help"
                        />
                        <button
                          type="button"
                          onClick={handlePromoCodeSubmit}
                          disabled={promoCodeValidating || !promoCode.trim() || rateLimited}
                          className="px-4 py-2 bg-[#26A94A] text-white rounded-lg hover:bg-[#1e7a3a] disabled:opacity-50 disabled:cursor-not-allowed font-medium cursor-pointer"
                        >
                          {promoCodeValidating ? t.validating : t.apply}
                        </button>
                      </div>

                      {/* Validation Messages */}
                      {promoCodeValidating && (
                        <p id="promo-code-help" className="mt-2 text-sm text-gray-600">
                          {t.validatingPromo}
                        </p>
                      )}

                      {promoCodeValid && promoCodeApplied && (
                        <p id="promo-code-help" className="mt-2 text-sm text-green-600 font-medium">
                          ✓ {t.promoApplied} {Math.round(promoCodeDiscount * 100)}% {t.discount.toLowerCase()}
                        </p>
                      )}

                      {promoCodeError && !rateLimited && (
                        <p id="promo-code-help" className="mt-2 text-sm text-red-600">
                          {promoCodeError}
                          {remainingAttempts > 0 && remainingAttempts < 5 && (
                            <span className="block mt-1">
                              {remainingAttempts === 1
                                ? t.oneAttemptLeft
                                : t.attemptsLeftPlural.replace("%s", remainingAttempts)}
                            </span>
                          )}
                        </p>
                      )}

                      {rateLimited && (
                        <div id="promo-code-help" className="mt-2 text-sm text-red-600">
                          <p className="font-medium">{t.tooManyAttempts}</p>
                          <p className="mt-1">
                            {t.timeRemaining} {Math.floor(remainingTime / 60)}:{String(remainingTime % 60).padStart(2, "0")}
                          </p>
                        </div>
                      )}
                    </div>

                  </div>

                  <button
                    type="submit"
                    disabled={
                      !stripe ||
                      submitting ||
                      (zipcodes.length >= 5 && zipcodeError) ||
                      !accepted ||
                      zipcodes.length < 5 ||
                      zipCheckLoading ||           // block while checking
                      (!csvtoken && !zipCheckLoading) // optional: keep disabled until verified
                    }
                    className="py-3 px-6 rounded-xl bg-[#26A94A] text-white font-semibold shadow hover:from-indigo-700 hover:to-purple-700 cursor-pointer disabled:opacity-60 w-full"
                  >
                    {submitting
                      ? t.processing
                      : zipCheckLoading
                        ? t.verifyingZipcodes
                        : `${t.pay} $${((isDiscountApplied ? discountedAmount : originalAmount) / 100).toFixed(2)}`}
                  </button>
                </div>
              </form>

              <div className="flex items-center justify-center pt-6">
                <Lock className="h-4 w-4 text-indigo-500 mr-2 mb-3" />
                <p className="text-xs text-gray-500 mt-1">
                  {t.secureEncrypted}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {buyNow === 'download' && (
        <div className="w-full max-w-lg">
          <div className="shadow-2xl border-6 border-[#26A94A] rounded-2xl overflow-hidden bg-white/80 backdrop-blur-sm">
            <div
              className="min-h-[24rem] p-8 flex flex-col items-center mt-3 text-center gap-5"
              role="status"
              aria-live="polite"
            >
              <div className="relative">
                <span className="absolute inset-0 rounded-full animate-ping bg-emerald-400/40"></span>
                <div className="relative z-10 grid h-16 w-16 place-items-center rounded-full bg-emerald-100 text-emerald-700">
                  <svg
                    className="h-8 w-8"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                </div>
              </div>

              <p className="text-2xl font-semibold text-[#26A94A] mt-6">
                {t.paymentSuccessful}
              </p>
              <p className="max-w-sm text-[#1465B7] font-semibold text-lg">
                {t.thanksPurchase}
              </p>

              <div className="mt-2 text-white">
                <button
                  onClick={handleDownload}
                  disabled={loadings}
                  aria-busy={loadings ? 'true' : 'false'}
                  className="inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-600 px-9 py-4 font-semibold text-[#1465B7] shadow transition
                       hover:bg-emerald-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600 focus-visible:ring-offset-2
                       disabled:opacity-70 disabled:cursor-not-allowed cursor-pointer"
                >
                  {loadings && (
                    <span
                      className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent text-white"
                      aria-hidden="true"
                      style={{ color: 'white' }}
                    />
                  )}
                  {loadings ? t.preparingDownload : t.downloadNow}
                </button>
              </div>

              {loadings && (
                <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800">
                  <div className="h-full w-1/2 animate-pulse rounded-full bg-emerald-500"></div>
                </div>
              )}

            </div>
          </div>
        </div>
      )}

      <Modal
        title={t.termsTitle}
        open={showTerms}
        centered
        onCancel={() => setShowTerms(false)}
        footer={[
          <div className="my-5 mx-5 gap-12" key="t1">
            <Button key="agree" type="primary" onClick={handleAgree} className="!h-10 w-32 !rounded-full mr-12 text-base" style={{ marginRight: 30, backgroundColor: '#26A94A', fontSize: 16, fontWeight: 600 }}>
              Agree
            </Button>,
            <Button key="cancel" onClick={() => setShowTerms(false)} className="!h-10 w-32 !rounded-full ml-12 bg-red-400" style={{ backgroundColor: 'red', color: 'white', fontSize: 16, fontWeight: 600 }}>
              Cancel
            </Button>,
          </div>
        ]}
        width={720}
      >
        <div className="text-gray-700 text-base max-h-[28rem] overflow-y-auto thin-scroll">
          <div className="p-5 text-left break-spaced">
            <div className="text-left">
              <p className="mb-3">Subscription Service Agreement</p>
              <p className="mb-3">
                IMPORTANT: BY ACCESSING ANY PART OF THIS ONLINE SERVICE (THE “SERVICE”), YOU REPRESENT THAT YOU ARE EITHER AT LEAST EIGHTEEN (18) YEARS OLD OR HAVE YOUR PARENT’S OR GUARDIAN’S CONSENT TO REGISTER. YOU ALSO AGREE TO ALL TERMS AND CONDITIONS IN THIS SUBSCRIPTION SERVICE AGREEMENT (THE “AGREEMENT”). IF YOU DO NOT AGREE TO THESE TERMS OR CANNOT COMPLY WITH THEM, YOU MUST IMMEDIATELY STOP USING THE SERVICE.
              </p>
              <p className="mb-3">
                Any lists or data provided through the Service must be kept strictly confidential and may not be shared with third parties or used for purposes other than those expressly permitted by this Agreement. You may only use this data as part of your own marketing programs. Under no circumstances may any portion of the data — or any derived information — be sold, rented, licensed, sublicensed, or disclosed. You may not use this data to enhance or develop third-party databases, or to create competing products or services.
              </p>
              <p className="mb-3">
                Any marketing materials, solicitations, advertisements, or communications sent to individuals included in a list generated using this Service must not reference specific selection criteria, presumed recipient characteristics, or the source of the recipient’s inclusion — unless the information originates from data you yourself provided. You must comply with all applicable laws, regulations, and industry best practices in connection with any use of the data. You may not use the data for spam, chain letters, pyramid schemes, sexually explicit content, or other inappropriate purposes. Upon request, you must provide samples of mailings, scripts, ad copy, or other communications you plan to use.
              </p>
              <p className="mb-3">
                You will instruct any employees or third parties who have access to the data about the restrictions in this Agreement and ensure physical and logical security of the data at least to the level you protect your own sensitive information. Access shall not be granted to incarcerated persons or institutions.
              </p>
              <p className="mb-3">
                You will maintain accurate records related to your use of the data for at least twelve (12) months after each marketing communication. This includes financial details and a file of communications (e.g. sample mailings, scripts, ad materials). We reserve the right to review or copy such records with prior written notice (at least three business days), during normal business hours.
              </p>
              <p className="mb-3">
                By using or ordering the Service, you accept all terms of this Agreement without modification. Any attempt to accept on different terms is void.
              </p>
              <p className="mb-3"><strong>1. The Service</strong></p>
              <p className="mb-3">
                The Service includes a web interface, marketing database, data encryption, data transmission, data access, and optionally synchronization software and storage. You are responsible for providing your own hardware, software, communications equipment, and paying any third-party access or network charges.
              </p>
              <p className="mb-3">
                The Service is provided without guarantee of uninterrupted availability or feature consistency. The provider reserves the right to change features or terms of this Agreement at any time without prior notice. All subscriptions run for twelve (12) consecutive months and may not be canceled before the end of that period. If you access or download data after your initial 12-month term, you agree to renew for another 12-month period.
              </p>
              <p className="mb-3"><strong>2. Use of Proprietary Software</strong></p>
              <p className="mb-3">
                Subject to this Agreement, you are granted a personal, non-sublicensable, non-transferable, non-exclusive license to use proprietary software (in object code form) and any associated database solely in conjunction with the Service. You may not reverse engineer, decompile, translate, or create derivative works from the software, nor remove proprietary notices. You may not use it for time-sharing or service bureau purposes, or on behalf of third parties. Upon termination, this license ends and you must cease all use. The software and database are provided “as is,” subject to disclaimers and limitations in this Agreement.
              </p>
              <p className="mb-3"><strong>3. Restrictions and Policies</strong></p>
              <p className="mb-3">
                You will not use the Service for spamming, chain letters, junk mail, illegal fax broadcasting, or contact lists of persons who have not given permission. You will not transmit content that is unlawful, harassing, abusive, threatening, obscene, or otherwise objectionable. You agree to defend and indemnify the provider against claims arising from your misuse of the Service. You must comply with all applicable laws including those governing copyright, trademark, defamation, and privacy.
              </p>
              <p className="mb-3">
                The provider respects customer privacy, but reserves the right to access or disclose content (e.g. data, files, messages) to comply with lawful requests, maintain operations, or protect itself or customers. You acknowledge that links to third-party sites or services may be provided, but the provider is not responsible for their content or availability.
              </p>
              <p className="mb-3"><strong>4. Support</strong></p>
              <p className="mb-3">
                Unless specifically contracted for, no obligation is assumed to provide hard-copy documentation, upgrades, enhancements, or technical support (including phone support) under this Agreement.
              </p>
              <p className="mb-3"><strong>5. Payment of Fees</strong></p>
              <p className="mb-3">
                You will supply accurate billing information (name, address, telephone) and update it as needed. Payment by fraudulent means may lead to immediate termination and legal action. You agree to pay the then-current fees for the Service in advance on a monthly basis. The provider reserves the right to change fees or institute new charges upon thirty (30) days’ notice.
              </p>
              <p className="mb-3">
                If your payment fails or account becomes delinquent, additional services may be suspended or removed. Restoration of archived data may incur additional fees. Any billing disputes must be raised within sixty (60) days of the first statement showing the error. Late invoices may accrue interest (e.g. 1.5% per month or as permitted by law) plus collection costs.
              </p>
              <p className="mb-3"><strong>6. Passwords and Security</strong></p>
              <p className="mb-3">
                You are responsible for maintaining confidentiality of your login credentials. You are fully responsible for activity under your account. You must notify us immediately of any unauthorized use or breach. The provider is not liable for losses from your failure to secure your account.
              </p>
              <p className="mb-3"><strong>7. Termination</strong></p>
              <p className="mb-3">
                This subscription automatically renews unless terminated by either party with thirty (30) days’ advance notice. The provider may terminate or suspend the Service immediately for breach. If terminated before the end of the twelve-month term, you remain liable for the remaining balance. Data may be deleted after 30 days of termination.
              </p>
              <p className="mb-3">
                On termination, you must cease all use of the software and data. Provisions that by nature should survive termination (e.g. confidentiality, liability, payment obligations) remain in effect. Use of other remedies does not affect termination rights.
              </p>
              <p className="mb-3"><strong>8. Warranty and Disclaimer</strong></p>
              <p className="mb-3">
                THE SERVICE IS PROVIDED “AS IS” WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED — INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. If allowed by law, liability is limited to resupplying the Service. The provider does not guarantee uninterrupted operation, error-free function, or absence of harmful components. Any downloaded material is used at your own risk, and you bear responsibility for damages or data loss.
              </p>
              <p className="mb-3"><strong>9. Limitation of Liability</strong></p>
              <p className="mb-3">
                THE TOTAL LIABILITY OF THE PROVIDER (IF ANY) WILL BE LIMITED TO THE FEES YOU PAID FOR THE SERVICE DURING THE PRIOR TWELVE (12) MONTHS. THE PROVIDER AND ITS LICENSORS WILL NOT BE LIABLE FOR INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS OR DATA, WHETHER FORESEEABLE OR NOT, EVEN IF ADVISED OF POSSIBILITY.
              </p>
              <p className="mb-3"><strong>10. Governing Law</strong></p>
              <p className="mb-3">
                This Agreement is governed by the laws of the state of Nebraska, without regard to conflict of laws rules. You and the provider agree to submit to the exclusive jurisdiction of the courts in Douglas County, Nebraska. Any legal claim must be filed within one (1) year of the event that gave rise to it. This Agreement supersedes all prior agreements and communications, and may only be modified by a written document signed by both parties. Neither party may assign this Agreement without the other’s written consent. In any action to enforce rights hereunder, the prevailing party may recover costs and attorney’s fees. All notices hereunder must be in writing. Failure by either party to enforce any term does not constitute waiver unless agreed in writing. This Agreement and all related documents are drafted in English.
              </p>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title={t.termsTitle}
        open={downloadShowTerms}
        centered
        onCancel={() => setDownloadShowTerms(false)}
        footer={[
          <div className="my-5 mx-5 gap-12" key="t2">
            <Button key="agree" type="primary" onClick={handleDownloadAgree} className="!h-10 w-32 !rounded-full mr-12 text-base" style={{ marginRight: 30, backgroundColor: '#26A94A', fontSize: 16, fontWeight: 600 }}>
              Agree
            </Button>,
            <Button key="cancel" onClick={() => setDownloadShowTerms(false)} className="!h-10 w-32 !rounded-full ml-12 bg-red-400" style={{ backgroundColor: 'red', color: 'white', fontSize: 16, fontWeight: 600 }}>
              Cancel
            </Button>,
          </div>
        ]}
        width={720}
      >
        <TermsAndCondition />
      </Modal>

    </div>
  );
}

/* -------------------- Express Checkout (isolated Elements) -------------------- */

function ExpressCheckoutInner({ onExpressReady }) {
  const stripe = useStripe();
  const elements = useElements(); // scoped to this Elements instance only

  const {
    email, name, zipcodes, selectedPrice, leadsCount,
    setBuyNow, setOrderNumber,
  } = useAppContext();

  const [submitting, setSubmitting] = useState(false);
  const [expressError, setExpressError] = useState("");

  const handleExpressCheckout = async (event) => {
    if (!stripe || !elements) return;
    setSubmitting(true);
    setExpressError("");
    try {
      const billing = event.billingDetails || {};
      const walletEmail = billing.email || email;
      const walletName  = billing.name  || name;

      // elements here ONLY contains ExpressCheckoutElement — no PaymentElement interference
      const { error: confirmError, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/thank-you`,
          receipt_email: walletEmail,
          payment_method_data: {
            billing_details: {
              name:    walletName  || undefined,
              email:   walletEmail || undefined,
              phone:   billing.phone   || undefined,
              address: billing.address || undefined,
            },
          },
        },
        redirect: "if_required",
      });

      if (confirmError) {
        const fail = new Error(confirmError.message);
        fail.payment_intent = confirmError.payment_intent;
        throw fail;
      }
      if (paymentIntent?.status !== "succeeded")
        throw new Error(`Payment not completed (status: ${paymentIntent?.status})`);

      // Generate order number
      const usDate = new Date().toLocaleString("en-US", { timeZone: "America/Chicago" });
      const now = new Date(usDate);
      const pad = (n) => n.toString().padStart(2, "0");
      const orderno = `${now.getFullYear()}${pad(now.getMonth()+1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
      setOrderNumber(orderno);

      // Record in DB then sync card brand / last4 / funding from Stripe
      try {
        const createRes = await fetch(`${API_BASE}/api/create-payment-onetime`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: walletEmail, name: walletName,
            amount: selectedPrice, currency: "usd",
            glsZipCode: zipcodes, orderno,
            paymentIntentId: paymentIntent?.id,
            expressPaymentType: event.expressPaymentType,
            leads_count: leadsCount || 50,
          }),
        });
        const createData = await createRes.json().catch(() => null);
        if (createData?.paymentId && paymentIntent?.id) {
          await fetch(`${API_BASE}/api/sync-payment-intent`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              paymentIntentId: paymentIntent.id,
              paymentId: createData.paymentId,
              email: walletEmail,
              name: walletName,
            }),
          }).catch(() => null);
        }
      } catch (dbErr) {
        console.warn("[express-checkout] DB record failed (payment already succeeded):", dbErr);
      }

      setBuyNow("download");
    } catch (err) {
      try {
        await fetch(`${API_BASE}/api/record-payment-failure`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            paymentIntentId: err?.payment_intent?.id || null,
            reason: err?.message || "Express payment failed",
            status: "failed",
            email: email || null,
            name: name || null,
            glsZipCode: zipcodes || null,
            amount: selectedPrice || null,
            leads_count: leadsCount || 50,
            createIfMissing: true,
          }),
        });
      } catch { /* non-blocking */ }
      setExpressError(err.message || "Express payment failed. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {expressError && (
        <div className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-800 mb-2">
          {expressError}
        </div>
      )}
      <ExpressCheckoutElement
        onReady={({ availablePaymentMethods }) => {
          onExpressReady(
            !!availablePaymentMethods &&
            Object.values(availablePaymentMethods).some(Boolean)
          );
        }}
        onConfirm={handleExpressCheckout}
        options={{
          buttonType: { applePay: "buy", googlePay: "buy", paypal: "paypal" },
          paymentMethods: {
            applePay: "always",
            googlePay: "always",
            paypal: "auto",
            link: "never",
            amazonPay: "never",
          },
          layout: { maxColumns: 3, maxRows: 1, overflow: "auto" },
        }}
      />
    </>
  );
}

/* -------------------- Wrapper -------------------- */

export default function StripeFinalCodeCheck({ hidePlanSelector = false, lang: langProp }) {
  const location = useLocation();
  const langFromPath = getLangFromPath(location.pathname);
  const lang = langProp ?? langFromPath;

  const [stripePromise, setStripePromise] = useState(null);
  // const [clientSecret, setClientSecret] = useState(null);
  const { clientSecret } = useAppContext();
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const key = await fetchPublishableKeyIfNeeded();
        if (!key || !key.startsWith("pk_"))
          throw new Error("Invalid publishable key (must start with pk_)");
        setStripePromise(loadStripe(key));
      } catch (e) {
        console.error(e);
        setError(e?.message || "Failed to init Stripe.");
      }
    })();
  }, []);

  const appearance = {
    theme: "stripe",
  };

  const options = {
    clientSecret,
    appearance,
  };
  return (
    <div>
      {error && (
        <div className="mx-auto my-4 max-w-xl rounded-xl border border-red-200 bg-red-50 p-4 text-red-800">
          <b>Configuration error</b>
          <div className="mt-1 text-sm">{error}</div>
        </div>
      )}

      {stripePromise && clientSecret && (
        <Elements stripe={stripePromise} options={options} key={clientSecret}>
          <PrettyForm hidePlanSelector={hidePlanSelector} lang={lang} stripePromise={stripePromise} />
        </Elements>
      )}
    </div>
  );
}
